/* eslint-disable jsx-a11y/alt-text */
//INIT
import React, { useContext, useEffect, useState } from "react"
import ServicosContext from "../../contexts/servicosContext"
import Segundos from "./components/Segundos"
//FUNCTIONS \ REQUESTS
import Package from "../../../package.json"
import {
    atualizarStatus,
    atualizarTempoEntrega,
    buscarestabelecimentos,
    controleAcessoAtualizar,
    controleAcessoVerificar,
    resumodia,
} from "../../services/integracao"

import DialogContentText from "@material-ui/core/DialogContentText"
import HomeWorkIcon from "@material-ui/icons/HomeWork"
import iconClienteFiel from "../../assets/icon-512x512.png"
import iconIfood from "../../assets/ifood-logo.png"
import { procurarPedido, verificarPrintQRCode } from "../../pages/RecebedorDePedidos/functions"
import Print from "./print"

import RepresentanteSelector from "../../functions/RepresentanteSelector"
import { dataFormatada, textoHTML } from "../../services/functionsGerais"
import { ObterStatusLojaIfood } from "../../services/integracao"

import api from "../../services/api"

//FILES
import desconected from "../../assets/desconected.jpg"
import Cabecalho from "../Cabecalho"
import Loading from "../Componentes/Loading"

//IMPORTS
import InputAdornment from "@material-ui/core/InputAdornment"
import Radio from "@material-ui/core/Radio"
import AirlineSeatReclineNormalIcon from "@material-ui/icons/AirlineSeatReclineNormal"
import MotorcycleIcon from "@material-ui/icons/Motorcycle"
import SettingsIcon from "@material-ui/icons/Settings"
import { useHistory } from "react-router-dom"

import Button from "@material-ui/core/Button"
import CircularProgress from "@material-ui/core/CircularProgress"
import FormControl from "@material-ui/core/FormControl"
import RadioGroup from "@material-ui/core/RadioGroup"
import Snackbar from "@material-ui/core/Snackbar"
import CancelIcon from "@material-ui/icons/Cancel"
import CheckBoxIcon from "@material-ui/icons/CheckBox"
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import EditIcon from "@material-ui/icons/Edit"
import PauseCircleFilledIcon from "@material-ui/icons/PauseCircleFilled"
import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled"
import ReceiptIcon from "@material-ui/icons/Receipt"
import RefreshIcon from "@material-ui/icons/Refresh"
import AlertFixo from "@material-ui/lab/Alert"
import { useSnackbar } from "notistack"

import Avatar from "@material-ui/core/Avatar"
import Checkbox from "@material-ui/core/Checkbox"
import Container from "@material-ui/core/Container"
import CssBaseline from "@material-ui/core/CssBaseline"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Divider from "@material-ui/core/Divider"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import IconButton from "@material-ui/core/IconButton"
import InputLabel from "@material-ui/core/InputLabel"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemAvatar from "@material-ui/core/ListItemAvatar"
import ListItemText from "@material-ui/core/ListItemText"
import MenuItem from "@material-ui/core/MenuItem"
import Select from "@material-ui/core/Select"
import Slide from "@material-ui/core/Slide"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import AccountCircleIcon from "@material-ui/icons/AccountCircle"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import DirectionsWalkIcon from "@material-ui/icons/DirectionsWalk"
import MuiAlert from "@material-ui/lab/Alert"
import { Col, Row } from "react-bootstrap"
import "./styles.css"

import Lista from "./tabelas/Lista"

import { RegistrarLogErro } from "../../services/clientefiel"
import BotaoIntegracoes from "./Integracoes/BotaoIntegracoes"
import ListaIntegracoes from "./Integracoes/ListaIntegracoes"
import { imprimirCode, imprimirHTML } from "./qzConfig"

import RingAudio from "./audios/ring.mp3"

const qz = require("qz-tray")

const useStyles = makeStyles(theme => ({
    fixedRegistrador: {
        position: "fixed",
        left: "2em",
        bottom: "2em",
        zIndex: 1000,
    },
    fixedStatus: {
        position: "fixed",
        left: "2em",
        bottom: "7em",
        zIndex: 1000,
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    botaoNext: {
        position: "absolute",
        padding: 0,
        margin: 0,
        right: "-1em",
    },
    iconNext3: {
        background: "#0080ff",
        borderRadius: "100%",
        color: "white",
    },
    iconNext4: {
        background: "#51a351",
        borderRadius: "100%",
        color: "white",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 999999,
        color: "#fff",
    },
    pos: {
        marginBottom: 12,
    },
    heading: {
        width: "100%",
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    primeiro: {
        backgroundColor: "#f0bb1f",
        borderRadius: "5px 5px 0 0",
        color: "white",
    },
    segundo: {
        borderRadius: "5px 5px 0 0",
        backgroundColor: "#fd7e14",
        color: "white",
    },
    terceiro: {
        borderRadius: "5px 5px 0 0",
        color: "white",
        backgroundColor: "#0080ff",
    },
    quarto: {
        borderRadius: "5px 5px 0 0",
        color: "white",
        backgroundColor: "#51a351",
    },
    rootList: {
        width: "100%!important",
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: "inline",
        width: "100%",
    },
}))

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />
})

export default function RecebedorDePedidos() {
    const theme = useTheme()
    const history = useHistory()
    const classes = useStyles()

    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )
    const aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))
    const autorizacao = localStorage.getItem("chaveSistema")

    const { handleRegistradorDePedidos, atualizarConfiguracoes, configuracoes } =
        useContext(ServicosContext)

    const [valorEntregasFuiApp, setValorEntregasFuiApp] = useState(false)
    const [modalChamarEntregadorFui, setModalChamarEntregadorFui] = useState(false)
    const [formaPagamentoSelecionadaFui, setFormaPagamentoSelecionadaFui] = useState({})

    const [openConfirmacaoPedidosRepetidosFui, setOpenConfirmacaoPedidosRepetidosFui] =
        useState(false)
    const [
        messageOpenConfirmacaoPedidosRepetidosFui,
        setMessageOpenConfirmacaoPedidosRepetidosFui,
    ] = useState("")
    const [pedidosEntregaFuiApp, setPedidosEntregaFuiApp] = useState([])
    const [statusLojaIfood, setStatusLojaIfood] = useState({})
    const [filaPrints, setFilaPrints] = useState([])
    const [mudancaConfiguracao, setMudancaConfiguracao] = useState(false)
    const [motivoCancelamento, setMotivoCancelamento] = React.useState(null)
    const [contratar, setContratar] = React.useState(false)
    const [registradorModal, setRegistradorModal] = React.useState(false)
    const [criarRegistradorModal, setCriarRegistradorModal] = React.useState(false)
    const [useEffect1, setUseEffect1] = useState(false)
    const [tabStatus, setTabStatus] = React.useState(mobile ? "VIEW" : "CRUD")
    const [impressorasQZ, setImpressorasQZ] = React.useState([])
    const [modalMotoqueiro, setModalMotoqueiro] = React.useState(false)
    const [modalEntregadorFuiDelivery, setModalEntregadorFuiDelivery] = React.useState({
        openModal: false,
    })
    const [loadingMotoqueiro, setLoadingMotoqueiro] = React.useState(false)
    const [loadingSalvarMotoqueiro, setLoadingSalvarMotoqueiro] = React.useState(false)
    const [motoqueiros, setMotoqueiros] = React.useState([])
    const busqueiTodosPedidos = React.useRef(false)
    const [modalSearchPedido, setModalSearchPedido] = React.useState(false)
    const [modalInformacoes, setModalInformacoes] = React.useState(false)
    const [modalInformacoesPedido, setModalInformacoesPedido] = React.useState({})
    const [modalInformacoesPedidoIndex, setModalInformacoesPedidoIndex] = React.useState(-1)
    const [arrayTodosPedidos, setArrayTodosPedidos] = React.useState([])
    const [arrayPrimeiro, setArrayPrimeiro] = React.useState([])
    const mostrarPrimeiro = React.useState(true)
    const [arraySegundo, setArraySegundo] = React.useState([])
    const [confirmacaoCancelado, setConfirmacaoCancelado] = React.useState([])
    const mostrarSegundo = React.useState(true)
    const [arrayTerceiro, setArrayTerceiro] = React.useState([])
    const mostrarTerceiro = React.useState(true)
    const [arrayQuarto, setArrayQuarto] = React.useState([])
    const mostrarQuarto = React.useState(true)

    const [loadingPedidos, setLoadingPedidos] = useState(true)

    const [expandListaIntegracoes, setExpandListaIntegracoes] = useState(false)

    const [motoqueiroSelecionado, setMotoqueiroSelecionado] = React.useState(-1)
    const [motoqueiroSelecionadoPedido, setMotoqueiroSelecionadoPedido] = React.useState([{}, null])

    const { user, printer, recebedor } = configuracoes

    const tamanhoLista = recebedor.prepararPedidoAutomatico ? 4 : 3
    console.log("-> Recebedor Configuração ", recebedor)

    const tipoPainelImpressao =
        impressorasQZ.length > 0
            ? "plugin" //qz
            : window.navigator.userAgent.includes("Electron")
            ? "software" //exe
            : "navegador" //padrao do navegador

    const { parametros } = user

    const [modalIfoodConfig, setModalIfoodConfig] = React.useState(false)
    const [modalConfiguracoes, setModalConfiguracoes] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [alert, setAlert] = useState({ status: false, tipo: "success", mesangem: "" })

    const [estabelecimentos, setEstabelecimentos] = React.useState([])
    const [openEstabelecimentos, setOpenEstabelecimentos] = React.useState(false)

    const {
        hashInternaClienteFielIfood,
        ativaIntegracaoIfood,
        listaMotivoCancelamento = [],
    } = parametros

    const tipoPrinter =
        tipoPainelImpressao === "plugin"
            ? printer.tipoImpressao
                ? printer.tipoImpressao
                : "code"
            : ""
    const tamanhoFonteSelect = printer.tamanhoFonteSelect ? printer.tamanhoFonteSelect : "media"

    const exibirTamanhoFonte = tipoPrinter === "html"
    const exibirImprimirLogo = tipoPrinter === "code"
    const exibirSeletorTamanho = tipoPrinter === "code"

    const selecionarMotoqueiro = event => {
        // setMotoqueiroSelecionado(event.target.value);
        atualizarSelecaoMotoqueiro(autorizacao, event.target.value)
    }

    const { enqueueSnackbar } = useSnackbar()
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
        // setAlert({"status": true, "tipo": tipo, "mesangem": msg});
    }

    const alertClose = (event, reason) => {
        if (reason === "clickaway") {
            return
        }
        setAlert({ status: false, tipo: alert.tipo, mesangem: alert.mesangem })
    }

    const todosPedidos = () => {
        return arraySegundo.concat(arrayTerceiro).concat(arrayQuarto)
    }

    const changeCheckFuiApp = (isChecked, identificador) => {
        const pedidos = JSON.parse(JSON.stringify(pedidosEntregaFuiApp))

        if (isChecked) {
            pedidos.push(identificador)
            setPedidosEntregaFuiApp(pedidos)
            // console.log("Target Check", arraySegundo)
        } else {
            const index = pedidos.indexOf(identificador)
            pedidos.splice(index) //remove
            setPedidosEntregaFuiApp(pedidos)
        }
    }
    const checkPedidoAgrupaFuiAppDelivery = (pedidoEscolhido, identificador, bairro) => {
        var isSameIdCheck = pedidoEscolhido?.id === identificador

        if (isSameIdCheck && pedidosEntregaFuiApp?.indexOf(identificador) === -1) {
            changeCheckFuiApp(isSameIdCheck, identificador)
        }

        var show = pedidosEntregaFuiApp?.indexOf(identificador) !== -1 || isSameIdCheck

        return (
            <FormControlLabel
                control={
                    <Checkbox
                        checked={show}
                        onChange={e => {
                            var checked = e.target.checked
                            const pedidos = JSON.parse(JSON.stringify(pedidosEntregaFuiApp))

                            if (checked) {
                                pedidos.push(identificador)
                                setPedidosEntregaFuiApp(pedidos)
                                // console.log("Target Check", arraySegundo)
                            } else {
                                const index = pedidos.indexOf(identificador)
                                pedidos.splice(index) //remove
                                setPedidosEntregaFuiApp(pedidos)
                            }
                        }}
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        name={identificador}
                        id={identificador}
                    />
                }
                label={"#" + identificador + " (" + bairro + ")"}
            />
        )
    }

    const showCheckbox = pedidoEscolhido => {
        var rows = []
        var qnt = arraySegundo.length
        for (var i = 0; i < qnt; i++) {
            const lista = arraySegundo
            const item = lista[i]
            var bairro = "--"
            if (item?.deliveryAddress?.neighborhood) {
                bairro = item?.deliveryAddress?.neighborhood
            }
            rows.push(checkPedidoAgrupaFuiAppDelivery(pedidoEscolhido, item.id, bairro))
        }
        return <Container>{rows}</Container>
    }

    const validarPedidosJaEnviadosFuiDelivery = async () => {
        try {
            const body = {
                pedidosId: pedidosEntregaFuiApp,
            }

            setLoading(true)
            await api
                .post(`entrega/fuiAppDelivery/validarPedidosJaEnviados/`, body, {
                    headers: { "Content-Type": "application/json", Authorization: autorizacao },
                })
                .then(response => {
                    setLoading(false)
                    if (response.status === 200) {
                        calcularValorEntregaFuiApp()
                    } else {
                        console.log("Resposta Validação", response)
                        alertStart("Erro ao validar pedido", "error")
                    }
                })
                .catch(error => {
                    setLoading(false)
                    let response = error.response.data
                    setOpenConfirmacaoPedidosRepetidosFui(true)
                    setMessageOpenConfirmacaoPedidosRepetidosFui(response.message)
                })
        } catch (error) {
            setLoading(false)
            console.log(error)
            RegistrarLogErro(error, "validarPedidosJaEnviados", pedidosEntregaFuiApp)
        }
    }

    const calcularValorEntregaFuiApp = async () => {
        try {
            const body = {
                pedidosId: pedidosEntregaFuiApp,
            }

            setLoading(true)
            await api
                .post(`entrega/fuiAppDelivery/consultarValor/`, body, {
                    headers: { "Content-Type": "application/json", Authorization: autorizacao },
                })
                .then(response => {
                    if (typeof response.data === "string") {
                        console.log(response.data)
                        alertStart("Erro ao consultar valores", "error")
                    } else {
                        const retorno = response.data
                        setValorEntregasFuiApp(retorno)
                        setModalChamarEntregadorFui(true)
                    }
                    setLoading(false)
                })
        } catch (error) {
            let response = error.response.data
            alertStart(response.message, "error")
            setLoading(false)
            RegistrarLogErro(error, "consultarValorEntrega", pedidosEntregaFuiApp)
        }
    }

    const chamarEntregadorFui = async (entregaObj, servicoId, formaPagamentoId) => {
        setLoading(true)

        try {
            const body = {
                calculoResponse: entregaObj.calculoResponse,
                entregaParam: entregaObj.entregaParam,
                calculaParam: entregaObj.calculaParam,
                servicoFuiApp: servicoId,
                tipoPagamentoFuiApp: formaPagamentoId,
            }

            await api
                .post(`entrega/fuiAppDelivery/solicitarEntrega/`, body, {
                    headers: { "Content-Type": "application/json", Authorization: autorizacao },
                })
                .then(response => {
                    console.log("Testeeeee ----", console.log(JSON.stringify(response)))
                    if (typeof response.data === "string") {
                        alertStart("Não foi possivel solicitar a entrega", "error")
                        console.log("Retorno Solicitacação Criada Type Error: ", response.data)
                    } else {
                        const retorno = response.data
                        alertStart(retorno.message, "success")
                        // setValorEntregasFuiApp(retorno)
                        // setModalChamarEntregadorFui(true);

                        console.log("Respostaaa Solicitacao", response.data)
                    }
                    setLoading(false)
                })
                .catch(error => {
                    let response = error.response.data
                    alertStart(response.message, "error")
                })
            setLoading(false)
        } catch (error) {
            setLoading(false)
            alertStart(error, "error")
            RegistrarLogErro(error, "solicitarEntrega", { entregaObj, servicoId, formaPagamentoId })
        }
    }

    const showDialogConfirmarValoresFui = () => {
        return (
            <Dialog
                fullScreen={fullScreen}
                open={modalChamarEntregadorFui}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => {
                    setFormaPagamentoSelecionadaFui(null)
                    setModalChamarEntregadorFui(false)
                }}
            >
                <DialogTitle>{"Confirmar Dados Entrega"}</DialogTitle>
                <DialogContent>
                    {valorEntregasFuiApp?.calculoResponse?.enderecoOrigem ? (
                        <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>
                                <h4>Origem</h4>
                            </Typography>
                            <Typography>
                                {" * " + valorEntregasFuiApp?.calculoResponse?.enderecoOrigem}
                            </Typography>
                        </Col>
                    ) : null}

                    {valorEntregasFuiApp?.calculoResponse?.destinos ? (
                        <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>
                                <h4>Destino(s)</h4>
                            </Typography>
                        </Col>
                    ) : null}

                    {valorEntregasFuiApp?.calculoResponse?.destinos?.map((destino, index) => (
                        <Col key={index} xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>{" * " + destino.endereco}</Typography>
                        </Col>
                    ))}

                    {!valorEntregasFuiApp?.calculoResponse?.servicos ? (
                        <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>
                                Infelizmente não encontramos serviços referente à sua solicitação
                            </Typography>
                        </Col>
                    ) : null}

                    <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            style={{ width: "60%" }}
                        >
                            <InputLabel id="pagamentofuiapp">Pagamento</InputLabel>
                            <Select
                                fullWidth
                                onChange={e => {
                                    setFormaPagamentoSelecionadaFui({
                                        name: e.target.name,
                                        id: e.target.value,
                                    })
                                }}
                                label="Forma de Pagamento"
                            >
                                {valorEntregasFuiApp?.formasPagamentoDisponiveis?.map(
                                    (formaPagamentoFui, index) => (
                                        <MenuItem
                                            name={formaPagamentoFui?.tipoPagamentoDesc}
                                            value={formaPagamentoFui?.tipoPagamentoID}
                                        >
                                            <em>{formaPagamentoFui?.tipoPagamentoDesc}</em>
                                        </MenuItem>
                                    )
                                )}
                            </Select>
                        </FormControl>
                    </Col>

                    {valorEntregasFuiApp?.calculoResponse?.servicos?.map((servico, index) => (
                        <Col key={index} xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                            <Typography>{"-------------------------"}</Typography>
                            <Typography>
                                {servico.servicoNome}
                                {" -- "}
                                {Intl.NumberFormat("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                }).format(servico.valor)}
                                <Button
                                    onClick={() => {
                                        if (!formaPagamentoSelecionadaFui?.id) {
                                            alertStart("Escolha a forma de pagamento", "error")
                                            return
                                        }
                                        chamarEntregadorFui(
                                            valorEntregasFuiApp,
                                            servico,
                                            formaPagamentoSelecionadaFui.id
                                        )
                                        setModalChamarEntregadorFui(false)
                                    }}
                                >
                                    Solicitar
                                </Button>
                            </Typography>
                        </Col>
                    ))}
                    <Col xs={12} md={12} lg={12} style={{ marginBottom: "1em" }}>
                        {"-------------------------"}
                    </Col>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setFormaPagamentoSelecionadaFui(null)
                            setModalChamarEntregadorFui(false)
                        }}
                    >
                        Voltar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    useEffect(() => {
        const efeitoAtivo = window.getCookie("efeito-sonoro-ativo")
            ? window.getCookie("efeito-sonoro-ativo") === "true"
            : true

        document.querySelector("#audiopedido")?.load()

        if (efeitoAtivo !== recebedor.efeitoSonoro) {
            recebedor.efeitoSonoro = efeitoAtivo
            atualizarConfiguracoes(configuracoes)
            setMudancaConfiguracao(true)

            window.setCookie("efeito-sonoro-ativo", efeitoAtivo, 9999)
        }
    }, [])

    useEffect(() => {
        try {
            buscarTodosPedidos(localStorage.getItem("chaveSistema"))
            verificarSeTemQZ()
        } catch (error) {
            RegistrarLogErro(error, "userEffect1")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabStatus])

    useEffect(() => {
        try {
            if (parametros?.estabelecimento?.id && tabStatus === "CRUD") {
                if (window.name === "") {
                    window.name = `${(parametros?.estabelecimento?.nome).replace(
                        /\s/g,
                        ""
                    )}${Math.random()}_${Package.version.replace(/ /g, "").replace("|", "")}`
                    atualizarTabNavegador(window.name)
                }
                const interval = setInterval(() => {
                    verificarTabNavegador(window.name)
                }, 5000)
                return () => clearInterval(interval)
            }
        } catch (error) {
            RegistrarLogErro(error, "userEffect2")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabStatus, configuracoes])

    useEffect(() => {
        try {
            if (tabStatus === "CRUD") {
                const interval = setInterval(() => {
                    verificarSeTemQZ()
                }, 20000)
                return () => clearInterval(interval)
            }
        } catch (error) {
            RegistrarLogErro(error, "userEffect3")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [impressorasQZ, configuracoes, tabStatus])

    const hasIfood = () => {
        return parametros?.ativaIntegracaoIfood
    }

    useEffect(() => {
        console.log("has_integrationn", hasIfood())
        if (hasIfood()) {
            if (tabStatus === "CRUD") {
                try {
                    verificarStatusLojaIfood(autorizacao)
                    var intervalLojaIFood = setInterval(function () {
                        verificarStatusLojaIfood(autorizacao)
                    }, 30000)
                    return () => clearInterval(intervalLojaIFood)
                } catch (error) {
                    console.log("Erro status Loja ifood", error)
                }
            }
        }
    }, [autorizacao, parametros])

    useEffect(() => {
        try {
            if (
                tabStatus === "CRUD" &&
                busqueiTodosPedidos.current &&
                recebedor.prepararPedidoAutomatico === true &&
                arrayPrimeiro.length
            ) {
                console.log("aguardando para preparar", arrayPrimeiro)

                console.log("preparando", arrayPrimeiro)
                prepararPedidosAutomaticos(arrayPrimeiro)
            }

            if (busqueiTodosPedidos.current && tabStatus === "CRUD") {
                const interval = setInterval(() => {
                    buscarNovosPedidosNovo(autorizacao)
                }, 5000)

                return () => {
                    clearInterval(interval)
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "userEffect4")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arrayPrimeiro])

    const atualizar = (loading = false) => {
        try {
            if (loading) {
                setLoadingPedidos(true)
            }
            //faz pull indiana
            if (parametros?.ativarIndiana) {
                var objPullIndiana = {
                    codigoFilial: parametros?.codigoFilialIndiana,
                    codigoEmpresa: parametros?.codigoEmpresaEntregaIndiana,
                }
                buscaPedidosIntegracaoIndiana(autorizacao, objPullIndiana)
            } else {
                buscarTodosPedidos(autorizacao)
            }
        } catch (error) {
            RegistrarLogErro(error, "atualizar")
        }
    }

    async function atualizarTempoEntregaEstabelecimento(tempo, estabelecimento, index) {
        try {
            estabelecimento.tempoEntregaTexto = tempo
            const response = await atualizarTempoEntrega(autorizacao, estabelecimento)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            const novoEstabelecimentos = Object.assign([], estabelecimentos)
            novoEstabelecimentos[index].tempoEntregaTexto = response.tempoEntregaTexto
            setEstabelecimentos(novoEstabelecimentos)
        } catch (error) {}
    }
    async function atualizarStatusEstabelecimento(e, estabelecimento, index) {
        try {
            const data = {
                idEstabelecimento: estabelecimento.id,
                situacao: e.target.value,
            }
            const response = await atualizarStatus(autorizacao, data)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            const novoEstabelecimentos = Object.assign([], estabelecimentos)
            novoEstabelecimentos[index].situacao = response.situacao
            novoEstabelecimentos[index].pausado = response.pausado
            setEstabelecimentos(novoEstabelecimentos)
        } catch (error) {}
    }

    const atualizarSelecaoMotoqueiro = async (Authorization, motoqueiroSelecionado) => {
        setLoadingSalvarMotoqueiro(true)

        const isMultiplosPedidos = !isNaN(Number(Object.keys(motoqueiroSelecionadoPedido[0])[0]))
        if (isMultiplosPedidos) {
            const pedidos = motoqueiroSelecionadoPedido[0]
            try {
                for (const idPedido in pedidos) {
                    const pedido = pedidos[Number(idPedido)]

                    if (!pedido.checked) continue

                    const isPedidoMesa = arraySegundo.find(
                        pedidoNaLista => pedidoNaLista.id === pedido.id
                    ).mesa
                    if (isPedidoMesa) continue

                    await api
                        .post(
                            `integracao/entregadores/selecionar/${
                                pedido.id
                            }/${motoqueiroSelecionado.replace("#", "")}`,
                            {},
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: Authorization,
                                },
                            }
                        )
                        .then(response => {
                            console.log("integracao/entregadores/selecionar", response)
                            if (typeof response.data === "string") {
                                alertStart("Erro ao atualizar motoqueiro", "error")
                            }
                        })
                }
                setModalMotoqueiro(false)
                atualizar()
            } catch (error) {
                RegistrarLogErro(error, "atualizarSelecaoMotoqueiro", motoqueiroSelecionado)
            }
        } else
            try {
                await api
                    .post(
                        `integracao/entregadores/selecionar/${
                            motoqueiroSelecionadoPedido[0].id
                        }/${motoqueiroSelecionado.replace("#", "")}`,
                        {},
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: Authorization,
                            },
                        }
                    )
                    .then(response => {
                        console.log("integracao/entregadores/selecionar", response)
                        if (typeof response.data === "string") {
                            alertStart("Erro ao atualizar motoqueiro", "error")
                        } else {
                            if (
                                gridStatus(motoqueiroSelecionadoPedido[0].status) === "SEGUNDO" &&
                                parametros?.atualizarEtapaAoAssociarEntregador
                            ) {
                                const posicao = buscarIndex(response.data, 2)
                                arraySegundo.splice(posicao, 1)
                                arrayTerceiro.unshift(response.data) //O método unshift() adiciona um ou mais elementos no início de um array e retorna o número de elementos atualizado.
                                setArraySegundo(arraySegundo)
                                setArrayTerceiro(arrayTerceiro)
                                // esta lógica basicamente passa o pedido automaticamente para em entrega após associar a um motoqueiro
                            } else if (
                                gridStatus(motoqueiroSelecionadoPedido[0].status) === "TERCEIRO"
                            ) {
                                const posicao = buscarIndex(response.data, 3)
                                arrayTerceiro[posicao] = response.data
                                setArrayTerceiro(arrayTerceiro)
                            } else if (
                                gridStatus(motoqueiroSelecionadoPedido[0].status) === "QUARTO"
                            ) {
                                const posicao = buscarIndex(response.data, 4)
                                arrayQuarto[posicao] = response.data
                                setArrayQuarto(arrayQuarto)
                            }
                            setModalMotoqueiro(false)
                        }
                    })
            } catch (error) {
                RegistrarLogErro(error, "atualizarSelecaoMotoqueiro", motoqueiroSelecionado)
            }
        setLoadingSalvarMotoqueiro(false)
    }

    const solicitarEntregaFuiDelivery = async (Authorization, pedido) => {
        setModalEntregadorFuiDelivery({
            ...modalEntregadorFuiDelivery,
            openModal: true,
            pedidoSelecionado: pedido,
        })
    }

    const procurarMotoqueiros = async (Authorization, selecionado, pedidoMotoqueiro) => {
        try {
            console.log("///////////////////pedidoMotoqueiro", pedidoMotoqueiro)
            setModalMotoqueiro(true)
            setLoadingMotoqueiro(true)
            await api
                .post(
                    `integracao/entregadores/listar`,
                    {},
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: Authorization,
                        },
                    }
                )
                .then(response => {
                    console.log("// motoqueiros> ", response)
                    if (response.data.codErro > 0 || typeof response.data === "string") {
                    } else {
                        setMotoqueiroSelecionado(selecionado)
                        setMotoqueiroSelecionadoPedido(pedidoMotoqueiro)
                        setMotoqueiros(response.data)
                    }
                })
            setLoadingMotoqueiro(false)
        } catch (error) {
            RegistrarLogErro(error, "procurarMotoqueiros", { selecionado, pedidoMotoqueiro })
            setLoadingMotoqueiro(false)
        }
    }

    const handleBuscarDadosEstabelecimentos = async () => {
        try {
            setLoading(true)
            const response = await buscarestabelecimentos(autorizacao)
            console.log("Parametros", response)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }
            setEstabelecimentos(response)
            setOpenEstabelecimentos(true)
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "handleBuscarDadosEstabelecimentos")
        }
        return {}
    }

    async function imprimirQz(configuracao) {
        let {
            pedido = {},
            texto = "",
            qtd = 1,
            qrcode = {},
            QZObrigatorio = false,
            numeroDaImpressora = 0,
            impressora = "",
        } = configuracao
        console.log("imprimirQz", texto)
        try {
            console.log("Impressão Qz - Recebedor de Pedidos")
            if (qz.websocket.isActive()) {
                if (!impressora || impressora == "vazio") {
                    impressora = await qz.printers.getDefault()
                }
                console.log("impressora()", impressora, texto, qtd)
                configuracao.impressora = impressora
                return impressao(configuracao)
            }

            qz.websocket
                .connect()
                .then(() => {
                    //console.log('Conectado QZ!');
                    // return qz.printers.find(); //array de impressoras
                    if (!impressora) {
                        impressora = qz.printers.getDefault()
                    }

                    const print = impressora //impressora padrao
                    localStorage.setItem("impressora", JSON.stringify(print))
                    return print
                })
                .then(printer => {
                    console.log("impressora()", printer, texto, qtd)

                    configuracao.impressora = printer
                    return impressao(configuracao)
                })
                .then(() => {})
                .catch(err => {
                    console.error("erro", err)
                })
        } catch (error) {
            RegistrarLogErro(error, "imprimirQz", configuracao)
        }
    }

    const impressao = configuracoes => {
        const {
            pedido = {},
            texto = "",
            qtd = 1,
            qrcode = {},
            QZObrigatorio = false,
            numeroDaImpressora = 0,
            impressora = "",
        } = configuracoes

        console.log("printer", printer)
        console.log(">printer", printer)

        console.log("tipoImpressao", printer.tipoImpressao)

        configuracoes.qz = qz
        configuracoes.printer = printer

        if (printer.imprimirLogo) {
            configuracoes.logo = parametros?.estabelecimento?.urlLogo
        }

        if (printer.tipoImpressao == "code") {
            imprimirCode(configuracoes)
            return true
        }
        imprimirHTML(configuracoes)
    }

    useEffect(() => {
        const pausarImpressao = async ms => new Promise(res => setTimeout(res, ms))

        const imprimirLista = async () => {
            const idUltimoPedido = localStorage.getItem("ultimoImprimir")
            const copiaArrayPrimeiro = [...arrayPrimeiro].reverse()
            for (let i = 0; i < copiaArrayPrimeiro.length; i++) {
                const pedido = copiaArrayPrimeiro[i]
                if (pedido.id > idUltimoPedido) {
                    localStorage.setItem("ultimoImprimir", pedido.id)
                    await pausarImpressao(2500)
                    mandarImprimir({
                        pedido: pedido,
                        texto: pedido.texto,
                    })
                }
            }
        }

        if (
            arrayPrimeiro.length > 0 &&
            recebedor.aceitarPedidoAutomatico &&
            recebedor.imprimirPedidoAutomatico &&
            tipoPainelImpressao === "navegador"
        ) {
            imprimirLista()
        }
    }, [arrayPrimeiro])

    const updatePedidosRecebidos = response => {
        console.log("response", response)
        setArrayTodosPedidos(response.data)
        var retornoPrimeiro = []
        var retornoSegundo = []
        var retornoTerceiro = []
        var retornoQuarto = []
        var aceitarAutomatico = []

        busqueiTodosPedidos.current = true
        ////console.log('todos pedidos', response)
        if (typeof response.data === "string") {
            // alertStart("Erro! Atualize a página!", "error")
            return true
        }
        for (var i = 0; i < response.data.length; i++) {
            const status = response.data[i].status

            if (gridStatus(status) === "ACEITARAUTOMATICO") {
                aceitarAutomatico.push(response.data[i])
            } else if (gridStatus(status) === "PRIMEIRO") {
                retornoPrimeiro.push(response.data[i])
            } else if (gridStatus(status) === "TERCEIRO") {
                retornoTerceiro.push(response.data[i])
            } else if (gridStatus(status) === "QUARTO") {
                retornoQuarto.push(response.data[i])
            } else {
                //NÃO FINALIZADO
                retornoSegundo.push(response.data[i])
            }
        }

        setArrayPrimeiro(retornoPrimeiro)
        setArraySegundo(retornoSegundo)
        setArrayTerceiro(retornoTerceiro)
        setArrayQuarto(retornoQuarto)
    }

    const buscaPedidosIntegracaoIndiana = async (Authorization, body) => {
        console.log("Buscando all Pedidos (INDIANA)", body)
        try {
            await api
                .post(`indiana/pull/all`, body, {
                    headers: { "Content-Type": "application/json", Authorization: Authorization },
                })
                .then(async response => {
                    console.log("response", response)
                    updatePedidosRecebidos(response)
                })
            setLoadingPedidos(false)
        } catch (error) {
            RegistrarLogErro(error, "buscaPedidosIntegracaoIndiana", body)
            alertStart("Erro ao buscar todos os Buscar Pedidos da Indiana!", "error")
            return false
        }
    }

    const buscarTodosPedidos = async Authorization => {
        console.log("Buscando all Pedidos", Authorization)
        try {
            await api
                .get(`integracao/orders/allday`, {
                    headers: { "Content-Type": "application/json", Authorization: Authorization },
                })
                .then(async response => {
                    updatePedidosRecebidos(response)
                })
            setLoadingPedidos(false)
        } catch (error) {
            RegistrarLogErro(error, "buscarTodosPedidos")
            alertStart("Erro ao buscar todos os pedidos!", "error")
            return false
        }
    }

    const atualizarTabNavegador = async name => {
        try {
            const response = await controleAcessoAtualizar(parametros?.estabelecimento?.id, name)

            if (response.retornoErro) {
                //algum erro
                console.error(
                    "controleAcessoAtualizar>> \n\n\n controleAcessoAtualizar>> ",
                    response
                )
            } else {
                //tudo certo
                console.log("controleAcessoAtualizar>> \n\n\n controleAcessoAtualizar>> ", response)
            }
        } catch (error) {
            RegistrarLogErro(error, "atualizarTabNavegador", name)
        }
    }

    const verificarTabNavegador = async name => {
        try {
            const response = await controleAcessoVerificar(parametros?.estabelecimento?.id, name)

            if (response.retornoErro) {
                //algum erro
                console.error(
                    "controleAcessoVerificar>> \n\n\n controleAcessoVerificar>> ",
                    response
                )
            } else {
                //tudo certo
                // console.log("controleAcessoVerificar>> \n\n\n controleAcessoVerificar>> ", response)
                if (response.exist === false) {
                    // setTabStatus("OFF")
                    // window.name = ""
                    document.getElementById("aviso-dois-recebedores").style.display = "block"
                } else {
                    document.getElementById("aviso-dois-recebedores").style.display = "none"
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "verificarTabNavegador", name)
        }
    }

    const verificarSeTemQZ = () => {
        try {
            //console.log('|||||||||||| verificar se tem qz')
            if (qz.websocket.isActive()) {
                buscarImpressoras()
            } else {
                qz.websocket
                    .connect()
                    .then(() => {
                        qz.printers
                            .details()
                            .then(function (data) {
                                for (var i = 0; i < data.length; i++) {
                                    console.log(
                                        data[i].name +
                                            " " +
                                            data[i].driver +
                                            " " +
                                            data[i].density +
                                            " " +
                                            data[i].trays
                                    )
                                }
                            })
                            .catch(function (e) {
                                console.error(e)
                            })

                        //console.log('Conectado QZ!');
                        buscarImpressoras()
                    })
                    .catch(err => {
                        console.error("Erro QZ", err.message)
                        // alertStart("Impressao automatica não identifica!", "error")
                        if (tipoPainelImpressao === "plugin") {
                            setImpressorasQZ([])
                        }
                    })
            }
        } catch (error) {
            RegistrarLogErro(error, "verificarSeTemQZ")
        }
    }

    const buscarImpressoras = async () => {
        try {
            if (!printer?.impressora) {
                printer.impressora = await qz.printers.getDefault()
                atualizarConfiguracoes(configuracoes)
            }

            const printers = await qz.printers.find()
            setImpressorasQZ(printers)
            //console.log('PRINTERS QZ >>>>>>> ', printers)
        } catch (error) {
            RegistrarLogErro(error, "buscarImpressoras", printer)
        }
    }

    const gridStatus = status => {
        if (status === 0 && recebedor.aceitarPedidoAutomatico) {
            return "ACEITARAUTOMATICO"
        } else if (
            status === 0 ||
            (recebedor.aceitarPedidoAutomatico && (status === 1 || status === 2))
        ) {
            return "PRIMEIRO"
        } else if (status === 3 || status === 6) {
            return "TERCEIRO"
        } else if (
            status === 4 ||
            status === -1 ||
            status === -2 ||
            status === -3 ||
            status === -4 ||
            status === -10
        ) {
            return "QUARTO"
        } else {
            return "SEGUNDO"
        }
    }

    const realizarCancelled = async ArrayPedidos => {
        try {
            //console.log("realizarCancelled>", ArrayPedidos)
            var encontrado = false
            var encontradoCancelado = false
            for (var i = 0; i < ArrayPedidos.length; i++) {
                const cancelando = ArrayPedidos[i]

                // if(parametros?.impressaoQz === true){
                if (tipoPainelImpressao === "plugin") {
                    console.log("imprimirqz", impressorasQZ)
                    if (printer.impressora) {
                        await imprimirQz({
                            texto: `${cancelando.texto} ${cancelando.texto} ${cancelando.texto}`,
                            qtd: 1,
                            impressora: printer.impressora,
                        })
                    }
                    if (printer.impressora2) {
                        await imprimirQz({
                            texto: `${cancelando.texto} ${cancelando.texto} ${cancelando.texto}`,
                            qtd: 1,
                            impressora: printer.impressora2,
                        })
                    }
                }

                for (var j = 0; j < arrayPrimeiro.length; j++) {
                    if (cancelando.correlationId === arrayPrimeiro[j].id) {
                        const tmp = arrayPrimeiro
                        tmp.splice(j, 1)
                        setArrayPrimeiro(tmp)
                        encontrado = true
                        break
                    }
                }

                if (encontrado === false) {
                    for (let j = 0; j < arrayQuarto.length; j++) {
                        if (cancelando.correlationId === arrayQuarto[j].id) {
                            const tmp = arrayQuarto
                            tmp[j] = await buscarInformacoesPedido(autorizacao, cancelando)
                            setArrayQuarto(tmp)
                            encontrado = true
                            encontradoCancelado = true
                            break
                        }
                    }
                }

                if (encontrado === false) {
                    for (let j = 0; j < arraySegundo.length; j++) {
                        if (cancelando.correlationId === arraySegundo[j].id) {
                            const tmp = arraySegundo
                            tmp.splice(j, 1)
                            setArraySegundo(tmp)
                            encontrado = true
                            break
                        }
                    }
                }

                if (encontrado === false) {
                    for (let j = 0; j < arrayTerceiro.length; j++) {
                        if (cancelando.correlationId === arrayTerceiro[j].id) {
                            const tmp = arrayTerceiro
                            tmp.splice(j, 1)
                            setArrayTerceiro(tmp)
                            encontrado = true
                            break
                        }
                    }
                }

                if (encontrado === false || encontradoCancelado === false) {
                    const tmp = arrayQuarto
                    tmp.unshift(await buscarInformacoesPedido(autorizacao, cancelando))
                    setArrayQuarto(tmp)
                }
            }
            setUseEffect1(!useEffect1)
        } catch (error) {
            RegistrarLogErro(error, "realizarCancelled", ArrayPedidos)
        }
    }

    const prepararPedidosAutomaticos = async arrayPedidos => {
        try {
            efeitoSonoro(true)
            console.log("prepararPedidosAutomaticos", arrayPedidos)
            console.log("**PREPARAR AUTOMATICO")
            for (let i = 0; i < arrayPedidos.length; i++) {
                const pedido = arrayPedidos[i]
                if (pedido.status === 1 || pedido.status === 2) {
                    await mudarStatusPara(7, autorizacao, pedido, i)
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "prepararPedidosAutomaticos", arrayPedidos)
        }
    }

    const aceitarPedidosAutomaticos = async arrayPedidos => {
        try {
            console.log("aceitarPedidosAutomaticos", arrayPedidos)
            for (let i = 0; i < arrayPedidos.length; i++) {
                const pedido = arrayPedidos[i]

                if (pedido.status === 0) {
                    await mudarStatusPara(1, autorizacao, pedido, i)
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "aceitarPedidosAutomaticos", arrayPedidos)
        }
    }

    const realizarPlaced = async ArrayPedidos => {
        //console.log("realizarPlaced>", ArrayPedidos)
        try {
            //console.log('arrayPrimeiro>', arrayPrimeiro)

            const pedidosParaAceitar = JSON.parse(JSON.stringify(arrayPrimeiro))

            for (var i = 0; i < ArrayPedidos.length; i++) {
                var jaTem = false

                for (var j = 0; j < pedidosParaAceitar.length; j++) {
                    if (pedidosParaAceitar[j].id === ArrayPedidos[i].correlationId) {
                        jaTem = true
                        // //console.log('coloca1> ', arrayPrimeiro[j])
                        // pedidosParaAceitar.push(arrayPrimeiro[j])
                        break
                    }
                }

                if (jaTem === false) {
                    const retorno = await buscarInformacoesPedido(autorizacao, ArrayPedidos[i])
                    //console.log("JSON.stringify(retorno) !== '{}'", JSON.stringify(retorno) !== "{}")
                    if (JSON.stringify(retorno) !== "{}") {
                        //console.log('coloca2> ', retorno)
                        pedidosParaAceitar.push(retorno)
                    }
                    setTimeout(() => {
                        /* SEGURAR UM TIME PARA NAO CHAMAR A FUNCAO VARIAS VEZES */
                    }, 1000)
                }
            }

            // //console.log('pedidos para aceitar', pedidosParaAceitar)

            if (recebedor.aceitarPedidoAutomatico === true) {
                aceitarPedidosAutomaticos(pedidosParaAceitar)
            } else {
                setArrayPrimeiro(pedidosParaAceitar)
            }
        } catch (error) {
            RegistrarLogErro(error, "realizarPlaced", ArrayPedidos)
            ////console.log("erro ao buscarInformacoes", error)
        }
    }

    const realizarAFila = fila => {
        try {
            console.log("realizarAFila> ", fila)
            if (fila.length > 0) {
                const placed = []
                const cancelled = []
                const filaPrint = JSON.parse(JSON.stringify(filaPrints))

                for (var i = 0; i < fila.length; i++) {
                    // eslint-disable-next-line default-case
                    switch (fila[i].code) {
                        case "PLACED":
                            placed.push(fila[i])
                            break
                        case "CANCELLED":
                            cancelled.push(fila[i])
                            break
                        case "UPDATE":
                            break
                        case "PRINT":
                        case "PRINT1":
                        case "PRINT2":
                            if (fila[i].exigirConfirmacao) {
                                filaPrint.push(fila[i].texto)
                            } else {
                                mandarImprimir({
                                    pedido: fila[i],
                                    texto: fila[i].texto,
                                    qtd: 1,
                                    qrcode: verificarPrintQRCode(fila[i]),
                                    QZObrigatorio: true,
                                    numeroDaImpressora:
                                        fila[i].code === "PRINT1"
                                            ? 1
                                            : fila[i].code === "PRINT2"
                                            ? 2
                                            : 0,
                                })
                            }
                    }
                }

                if (filaPrint.length > 0) {
                    setFilaPrints(filaPrint)
                }

                if (placed.length > 0) {
                    realizarPlaced(placed)
                }

                if (cancelled.length > 0) {
                    realizarCancelled(cancelled)
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "realizarAFila", fila)
        }
    }

    const verificarSeDeveBuscarIfood = () => {
        if (
            !localStorage.getItem("ultimoEventSpollingIfood") ||
            new Date() - new Date(localStorage.getItem("ultimoEventSpollingIfood")) > 30000
        ) {
            localStorage.setItem("ultimoEventSpollingIfood", new Date())
            return true
        }

        return false
    }

    const verificarStatusLojaIfood = async Authorization => {
        console.log("Verificando Loja iFood")
        const retorno = await ObterStatusLojaIfood(parametros?.estabelecimento, Authorization)
        if (retorno.retornoErro) {
            setStatusLojaIfood({
                title: "...",
                message: "...",
            })
            return false
        }
        console.log("Retorno Status", retorno)

        var body = retorno
        setStatusLojaIfood({
            title: body?.available ? "Loja Aberta" : "Loja Fechada",
            message: body?.message,
            extraInfo: body?.extraInfo,
        })
    }

    const buscarNovosPedidosNovo = async Authorization => {
        try {
            await api
                .get(`integracao/eventspolling`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: Authorization,
                        //"fixed_token_ifood": hashInternaClienteFielIfood, //deprecated
                        //"ifood_integration_active": ativaIntegracaoIfood, //deprecated
                        //"need_call_polling_ifood": verificarSeDeveBuscarIfood(), //deprecated
                    },
                })
                .then(async response => {
                    console.log(
                        "---- Buscando novos Pedidos ---- (httpStatus: " + response.status + ")"
                    )
                    if (response && response.data) {
                        if (response?.lenght) {
                            console.log(" -- Novos Pedidos ---- ", response.data)
                        }
                    }
                    const resp = response.data  

                    const allFila = []

                    for (let j = 0; j < resp.length; j++) {
                        console.log(j, " INICIO")
                        await api
                            .post(`integracao/events/acknowledgmentsingle`, resp[j], {
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: Authorization,
                                },
                            })
                            .then(response => {
                                console.log(" === OK", response)
                                if (response.data.codErro > 0) {
                                    // alertStart(`${response.data.mensagem}`, "error")
                                } else {
                                    allFila.push(resp[j])
                                }
                            })
                        console.log(j, " FIM")
                    }

                    if (resp.length > 0) {
                        realizarAFila(allFila)
                    }
                })
        } catch (error) {
            RegistrarLogErro(error, "buscarNovosPedidosNovo")
        }
    }

    const efeitoSonoro = tocar => {
        try {
            const myAudio = document.getElementById("audiopedido")
            if (myAudio && tocar && recebedor.efeitoSonoro === true) {
                myAudio.play()
                if (!!recebedor.duracaoEfeitoSonoro && recebedor.duracaoEfeitoSonoro !== "0") {
                    window.setTimeout(() => {
                        efeitoSonoro(false)
                    }, 1000 * Number(recebedor.duracaoEfeitoSonoro))
                } else if (recebedor.prepararPedidoAutomatico === true) {
                    window.setTimeout(function () {
                        efeitoSonoro(false)
                    }, 5000)
                }
            } else if (myAudio) {
                myAudio.pause()
            }
        } catch (error) {
            setTimeout(function () {
                efeitoSonoro(tocar)
            }, 1000)
        }
    }

    if (recebedor.prepararPedidoAutomatico != true || tabStatus === "OFF") {
        if (arrayPrimeiro.length > 0 || tabStatus === "OFF") {
            efeitoSonoro(true)
            console.log("Efeito Sonoro (true)")
        } else {
            efeitoSonoro(false)
        }
    }

    const buscarInformacoesPedido = async (Authorization, pedido) => {
        //console.log('buscarInformacoesPedido', pedido)
        var retorno = {}
        try {
            await api
                .get(`integracao/orders/${pedido.correlationId}`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: Authorization,
                        //"fixed_token_ifood": hashInternaClienteFielIfood, //deprecated
                        // "ifood_integration_active": ativaIntegracaoIfood //deprecated
                    },
                })
                .then(response => {
                    //console.log("buscarInformacoesPedido", response.data)
                    response.data.evento = pedido
                    retorno = response.data
                })
        } catch (error) {
            RegistrarLogErro(error, "buscarInformacoesPedido", pedido)
        }
        return retorno
    }

    const buscarStatus = pedido => {
        /* 
      AGUARDANDO_ACEITACAO = 0;
      ACEITO = 1;
      CONFIRMACAO_VISUALIZADA = 2;
      EM_ENTREGA = 3;
      ENTREGUE = 4;
      PAGO = 5;
      PRONTO = 6;
      EM_PRODUCAO = 7;
      AGUARDANDO ATUALIZAR STATUS = 10;

      CANCELADO_PELO_DISTRIBUIDOR = -1;
      CANCELADO_PELO_CLIENTE = -2;
      NAO_ENTREGUE = -3;
      EXPIRADO = -4;
      CHARGEBACK = -10;
    */
        switch (pedido.status) {
            case 0:
                return "Aguardando Aceitação"
            case 1:
            case 2:
                return "Aceito"
            case 3:
                if (pedido.type === "1") return "Pronto P/ Retirada"
                return "Saiu P/ Entrega"
            case 4:
                return "Entregue"
            case 5:
                return "Pago"
            case 6:
                if (pedido.type === "2") return "Saiu P/ Entrega"
                return "Pronto P/ Retirada"
            case 7:
                return "Preparação"
            case -1:
                return "Loja Cancelou"
            case -2:
                return "Cliente Cancelou"
            case -3:
                return "Não Entregue"
            case -4:
                return "Expirado"
            case -10:
                return "ChargeBack"

            default:
                return "Não Identificado"
        }
    }

    const buscarIndex = (pedido, array) => {
        try {
            if (array === 4) {
                for (let i = 0; i < arrayQuarto.length; i++) {
                    if (arrayQuarto[i].id === pedido.id) {
                        return i
                    }
                }
            } else if (array === 3) {
                for (let i = 0; i < arrayTerceiro.length; i++) {
                    if (arrayTerceiro[i].id === pedido.id) {
                        return i
                    }
                }
            } else if (array === 2) {
                for (let i = 0; i < arraySegundo.length; i++) {
                    if (arraySegundo[i].id === pedido.id) {
                        return i
                    }
                }
            } else if (array === 1) {
                for (let i = 0; i < arrayPrimeiro.length; i++) {
                    if (arrayPrimeiro[i].id === pedido.id) {
                        return i
                    }
                }
            }
        } catch (error) {
            RegistrarLogErro(error, "buscarIndex", { pedido, array })
        }
        // nao pode acontecer
        return -1
    }

    const primerioParaSegundo = pedido => {
        try {
            const posicao = buscarIndex(pedido, 1)

            const pedidoAceito = arrayPrimeiro.splice(posicao, 1)[0]

            if (recebedor.aceitarPedidoAutomatico) {
                pedidoAceito.status = 7 //em producao
            }

            arraySegundo.unshift(pedidoAceito)
            //adiciona um ou mais elementos no início de um array e retorna o número de elementos atualizado.

            setArraySegundo(arraySegundo)

            setArrayPrimeiro(arrayPrimeiro)
        } catch (error) {
            RegistrarLogErro(error, "primerioParaSegundo", pedido)
        }
    }

    const atualizarArraysCancelarPedido = (pedido, index, status) => {
        ////console.log('atualizarArraysCancelarPedido', pedido, index, status)
        try {
            if (gridStatus(status) === "QUARTO") {
                const posicao = buscarIndex(pedido, 4)
                arrayQuarto[posicao].status = -1
                setArrayQuarto(arrayQuarto)
            } else if (gridStatus(status) === "TERCEIRO") {
                const posicao = buscarIndex(pedido, 2)
                arrayTerceiro.splice(posicao, 1)
                arrayQuarto.unshift(pedido)
                setArrayQuarto(arrayQuarto)
                setArrayTerceiro(arrayTerceiro)
            } else if (gridStatus(status) === "SEGUNDO") {
                const posicao = buscarIndex(pedido, 2)
                arraySegundo.splice(posicao, 1)
                arrayQuarto.unshift(pedido)
                setArraySegundo(arraySegundo)
                setArrayQuarto(arrayQuarto)
            } else if (gridStatus(status) === "PRIMEIRO") {
                const posicao = buscarIndex(pedido, 1)

                const removidoPedido = arrayPrimeiro.splice(posicao, 1)[0]
                removidoPedido.status = -1
                arrayQuarto.unshift(removidoPedido)
                setArrayPrimeiro(arrayPrimeiro)
                setArrayQuarto(arrayQuarto)
                localStorage.setItem("arrayprimeiro", JSON.stringify(arrayPrimeiro))
            }
        } catch (error) {
            RegistrarLogErro(error, "atualizarArraysCancelarPedido", { pedido, index, status })
        }
    }

    const resumoDoDia = async pedido => {
        const now = new Date()

        const formasDePagamento = []
        const pedidos = todosPedidos()
        var confirmados = 0
        var valorConfirmados = 0.0
        let entregadores = []

        try {
            const response = await resumodia(autorizacao)
            if (response.retornoErro) {
                //algum erro
            } else {
                //tudo certo
                entregadores = response
            }
        } catch (error) {
            RegistrarLogErro(error, "await")
        }

        try {
            pedidos.forEach(pedido => {
                if (pedido.status > 0) {
                    confirmados++
                    valorConfirmados += pedido.totalPrice

                    if (formasDePagamento.length === 0) {
                        formasDePagamento.push({
                            code: pedido.payments.code,
                            nome: pedido.payments.name,
                            quantidade: 1,
                            valor: pedido.totalPrice,
                        })
                    } else {
                        var tem = false
                        for (var i = 0; i < formasDePagamento.length; i++) {
                            if (pedido.payments.code === formasDePagamento[i].code) {
                                formasDePagamento[i].quantidade++
                                formasDePagamento[i].valor += pedido.totalPrice
                                tem = true
                                break
                            }
                        }
                        if (tem === false) {
                            formasDePagamento.push({
                                code: pedido.payments.code,
                                nome: pedido.payments.name,
                                quantidade: 1,
                                valor: pedido.totalPrice,
                            })
                        }
                    }
                }
            })

            var textoFormaDePagamento = ""
            formasDePagamento.forEach(formaPagamento => {
                textoFormaDePagamento += `> (${formaPagamento.quantidade}) ${
                    formaPagamento.nome.substring(0, 15) + "."
                } ${Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
                    formaPagamento.valor
                )}\n`
            })

            var textoEntregadores = ""

            if (parametros?.possuiModuloEntregadores) {
                textoEntregadores = "----------- Entregadores ------------\n"
                entregadores.forEach(entregador => {
                    textoEntregadores += `
          >>> ${entregador.nome} <<<
          Vr. Total: ${Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
              entregador.valorPedidos
          )}
    
          Qtd. Entregas: ${entregador.qtdEntregas}
          Vr. Entregas: ${Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
              entregador.valorEntregas
          )}
    
          Vr. Pedidos - Dinheiro: ${Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
          }).format(entregador.valorDinheiro)}
          Vr. Pedidos - Cartão/Outros: ${Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
          }).format(entregador.valorCartao)}
    
          Cobrar do entregador: ${Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
          }).format(entregador.valorCobrarDoEntregador)}\n
          `
                })
            }

            // Data: ${now.getDay()}/${now.getMonth()}/${now.getFullYear()} Hora: ${now.getDate()}:${now.getMinutes()}

            const texto = `
      ------ Resumo do Movimento ------
      
      Data: ${dataFormatada(now)}
      Pedidos confirmados: ${confirmados}
      Total das vendas: ${Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
          valorConfirmados
      )}
  
      ------ Formas de Pagamento ------
  
      ${textoFormaDePagamento}
      ${textoEntregadores}
  
      `

            console.log(texto)
            mandarImprimir({
                texto: texto,
                qtd: 1,
            })
        } catch (error) {
            RegistrarLogErro(error, "resumodia", pedidos)
        }
    }

    const mandarImprimir = async configs => {
        const {
            pedido = {},
            texto = "",
            qtd = 1,
            qrcode = {},
            QZObrigatorio = false,
            numeroDaImpressora = 0,
        } = configs
        try {
            console.log("mandarImprimir > configs", configs)

            if (parametros.assinaturaLimitada === true) {
                alertStart(
                    "Não foi impresso, porque sua assinatura está limitada por inadimplência.",
                    "info"
                )
                return false
            }

            console.log(">printer", printer)

            if (tipoPainelImpressao === "navegador") {
                if (QZObrigatorio === false) {
                    document.getElementById("rootPrint").innerHTML = texto.replace(
                        /(?:\r\n|\r|\n)/g,
                        "<br>"
                    )
                    window.setTimeout(function () {
                        if (parametros?.agruparViasImpressao) {
                            // if(true){
                            window.print()
                        } else {
                            for (var j = 0; j < qtd; j++) {
                                window.print()
                            }
                        }
                    }, 200)
                }
            }

            if (tipoPainelImpressao === "plugin") {
                if (!mobile) {
                    if (
                        !!printer.impressora &&
                        printer.impressora !== "vazio" &&
                        (numeroDaImpressora === 0 || numeroDaImpressora === 1)
                    ) {
                        console.log("imprimirqz", printer.impressora)
                        configs.impressora = printer.impressora

                        if (parametros?.impressaoAlternada && pedido?.texto1) {
                            configs.texto = pedido?.texto1
                        }

                        await imprimirQz(configs)
                    }

                    if (
                        !!printer.impressora2 &&
                        printer.impressora2 !== "vazio" &&
                        (numeroDaImpressora === 0 || numeroDaImpressora === 2)
                    ) {
                        console.log("imprimirqz", printer.impressora2)
                        configs.impressora = printer.impressora2

                        if (parametros?.impressaoAlternada && pedido?.texto2) {
                            configs.texto = pedido?.texto2
                        }

                        await imprimirQz(configs)
                    }

                    if (printer.impressora !== "vazio" || printer.impressora2 !== "vazio") {
                        return true
                    }
                }
            }

            if (tipoPainelImpressao === "software") {
                console.log(`01[${texto}]{${qtd}}`)
            }
        } catch (error) {
            RegistrarLogErro(error, "mandarImprimir", configs)
        }
    }

    const mudarStatusPara = async (status, autorizacao, pedido, index) => {
        console.log("status, autorizacao, pedido, index", status, autorizacao, pedido, index)
        try {
            switch (status) {
                case -1:
                    setConfirmacaoCancelado([autorizacao, pedido, index])
                    break
                case 1:
                    console.log("aceitarPedido", aceitarPedido)
                    // if (pedido.status < 1 && recebedor.aceitarPedidoAutomatico === false) {
                    //   document.getElementById(`buttonVer${pedido.id}`).style.display = 'none'
                    //   document.getElementById(`buttonAceitar${pedido.id}`).style.display = 'none'
                    //   document.getElementById(`buttonCancelar${pedido.id}`).style.display = 'none'
                    // }

                    await aceitarPedido(autorizacao, pedido, index)
                    break
                case 7:
                    emProducao(autorizacao, pedido, index)
                    break
                case 3:
                    prontoEntrega(autorizacao, pedido, index)
                    break
                case 6:
                    prontoRetirada(autorizacao, pedido, index)
                    break
                case 4:
                    finalizarPedido(autorizacao, pedido, index)
                    break

                default:
                    break
            }
        } catch (error) {
            RegistrarLogErro(error, "mudarStatusPara", { status, autorizacao, pedido, index })
        }
    }

    const finalizarPedido = async (Authorization, pedido, index) => {
        setLoading(true)
        try {
            await api
                .post(
                    `integracao/orders/${pedido.id}/statuses/delivery`,
                    {},
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: Authorization,
                            // "fixed_token_ifood": hashInternaClienteFielIfood, //deprecated
                            // "ifood_integration_active": ativaIntegracaoIfood //deprecated
                        },
                    }
                )
                .then(response => {
                    ////console.log("delivery> ", response)
                    if (gridStatus(pedido.status) === "QUARTO") {
                        setModalInformacoes(false)
                        const posicao = buscarIndex(pedido, 4)
                        arrayQuarto[posicao] = response.data
                        setArrayQuarto(arrayQuarto)
                    } else if (gridStatus(pedido.status) === "TERCEIRO") {
                        setModalInformacoes(false)
                        const posicao = buscarIndex(pedido, 3)
                        arrayTerceiro.splice(posicao, 1)
                        arrayQuarto.unshift(response.data)
                        setArrayQuarto(arrayQuarto)
                        setArrayTerceiro(arrayTerceiro)
                    } else {
                        //SEGUNDO

                        setModalInformacoes(false)
                        const pedido = response.data
                        const posicao = buscarIndex(pedido, 2)
                        arraySegundo.splice(posicao, 1)
                        arrayQuarto.unshift(pedido)
                        setArraySegundo(arraySegundo)
                        setArrayQuarto(arrayQuarto)
                    }
                    setModalInformacoes(false)
                    setModalInformacoesPedido({})
                    setModalInformacoesPedidoIndex(-1)
                })
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "finalizarPedido", { pedido, index })
            alertStart("Erro ao mudar status para finalizarPedido", "error")
            setLoading(false)
        }
    }

    const prontoRetirada = async (Authorization, pedido, index) => {
        setLoading(true)
        try {
            await api
                .post(
                    `integracao/orders/${pedido.id}/statuses/readyToDeliver`,
                    {},
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: Authorization,
                        },
                    }
                )
                .then(response => {
                    ////console.log("readyToDeliver> ", response)

                    if (gridStatus(pedido.status) === "TERCEIRO") {
                        //manter o pedido no array verde

                        const posicao = buscarIndex(pedido, 3)
                        arrayTerceiro[posicao] = response.data
                        setArrayTerceiro(arrayTerceiro)
                    } else if (gridStatus(pedido.status) === "QUARTO") {
                        setModalInformacoes(false)
                        const posicao = buscarIndex(pedido, 4)
                        arrayQuarto.splice(posicao, 1)
                        arrayTerceiro.unshift(response.data)
                        setArrayQuarto(arrayQuarto)
                        setArrayTerceiro(arrayTerceiro)
                    } else {
                        setModalInformacoes(false)
                        const pedido = response.data
                        const posicao = buscarIndex(pedido, 2)
                        arraySegundo.splice(posicao, 1)
                        arrayTerceiro.unshift(pedido)
                        setArraySegundo(arraySegundo)
                        setArrayTerceiro(arrayTerceiro)
                    }

                    setModalInformacoes(false)
                    setModalInformacoesPedido({})
                    setModalInformacoesPedidoIndex(-1)
                })
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "prontoRetirada", { pedido, index })
            alertStart("Erro ao mudar status para prontoRetirada", "error")
            setLoading(false)
        }
    }

    const prontoEntrega = async (Authorization, pedido, index) => {
        setLoading(true)
        try {
            await api
                .post(
                    `integracao/orders/${pedido.id}/statuses/dispatch`,
                    {},
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: Authorization,
                        },
                    }
                )
                .then(response => {
                    ////console.log("preparation> ", response)

                    if (gridStatus(pedido.status) === "TERCEIRO") {
                        //manter o pedido no array verde

                        const posicao = buscarIndex(pedido, 3)

                        arrayTerceiro[posicao] = response.data
                        setArrayTerceiro(arrayTerceiro)
                    } else if (gridStatus(pedido.status) === "QUARTO") {
                        setModalInformacoes(false)
                        const posicao = buscarIndex(pedido, 4)
                        arrayQuarto.splice(posicao, 1)
                        arrayTerceiro.unshift(response.data)
                        setArrayQuarto(arrayQuarto)
                        setArrayTerceiro(arrayTerceiro)
                    } else {
                        setModalInformacoes(false)
                        const pedido = response.data
                        const posicao = buscarIndex(pedido, 2)
                        arraySegundo.splice(posicao, 1)
                        arrayTerceiro.unshift(pedido)
                        setArraySegundo(arraySegundo)
                        setArrayTerceiro(arrayTerceiro)
                    }

                    setModalInformacoes(false)
                    setModalInformacoesPedido({})
                    setModalInformacoesPedidoIndex(-1)
                })
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "prontoEntrega", { pedido, index })
            alertStart("Erro ao mudar status para prontoEntrega", "error")
            setLoading(false)
        }
    }

    const emProducao = async (Authorization, pedido, index, ignorarPosicao = false) => {
        setLoading(true)
        try {
            await api
                .post(
                    `integracao/orders/${pedido.id}/statuses/preparation`,
                    {},
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: Authorization,
                        },
                    }
                )
                .then(response => {
                    ////console.log("preparation> ", response)
                    if (gridStatus(pedido.status) === "PRIMEIRO") {
                        const posicao = buscarIndex(pedido, 1)
                        arrayPrimeiro[posicao] = response.data
                        setArrayPrimeiro(arrayPrimeiro)
                        primerioParaSegundo(pedido)
                    } else if (gridStatus(pedido.status) === "TERCEIRO") {
                        //tirar o pedido do array verde

                        const posicao = buscarIndex(pedido, 3)
                        arrayTerceiro.splice(posicao, 1)
                        setArrayTerceiro(arrayTerceiro)

                        arraySegundo.unshift(response.data)
                        setArraySegundo(arraySegundo)
                    } else if (gridStatus(pedido.status) === "QUARTO") {
                        //tirar o pedido do array verde

                        const posicao = buscarIndex(pedido, 4)
                        arrayQuarto.splice(posicao, 1)
                        setArrayQuarto(arrayQuarto)

                        arraySegundo.unshift(response.data)
                        setArraySegundo(arraySegundo)
                    } else {
                        if (ignorarPosicao) {
                            arraySegundo.unshift(response.data)
                        } else {
                            const posicao = buscarIndex(pedido, 2)
                            arraySegundo[posicao] = response.data
                        }
                        setArraySegundo(arraySegundo)
                    }

                    setModalInformacoes(false)
                    setModalInformacoesPedido({})
                    setModalInformacoesPedidoIndex(-1)
                })
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "emProducao", { pedido, index })
            alertStart("Erro ao mudar status para emProducao", "error")
            setLoading(false)
        }
    }

    const aceitarPedido = async (Authorization, pedido, index) => {
        console.log(pedido.id, " Inicio === CONFIRMAÇÃO")

        if (!recebedor.aceitarPedidoAutomatico) {
            setLoading(true)
        }

        try {
            await api
                .post(
                    `integracao/orders/${pedido.id}/statuses/confirmation`,
                    {},
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: Authorization,
                        },
                    }
                )
                .then(response => {
                    console.log(pedido.id, " resposta ", response)

                    // response.data.status = 1

                    if (gridStatus(response.data.status) === "QUARTO") {
                        console.log("QUARTO", response.data)

                        for (var i = 0; i < arrayPrimeiro.length; i++) {
                            if (arrayPrimeiro[i].id === response.data.id) {
                                arrayPrimeiro.splice(i, 1)
                                setArrayPrimeiro(arrayPrimeiro)
                            }
                        }

                        alertStart(`${response.data.descricaoStatus}`, "warning")
                    } else if (gridStatus(response.data.status) === "TERCEIRO") {
                        console.log("TERCEIRO")

                        arrayTerceiro.unshift(response.data)
                        setArrayTerceiro(arrayTerceiro)
                        alertStart(`${response.data.descricaoStatus}`, "warning")
                    } else if (
                        gridStatus(response.data.status) === "SEGUNDO" &&
                        recebedor.aceitarPedidoAutomatico === false
                    ) {
                        console.log("SEGUNDO")

                        const posicao = buscarIndex(response.data, 1)
                        const pedidoAceito = arrayPrimeiro.splice(posicao, 1)[0]
                        //console.log(" === pedido", pedidoAceito)
                        if (recebedor.aceitarPedidoAutomatico) {
                            pedidoAceito.status = 7 //em producao
                        } else {
                            pedidoAceito.status = 1 //aceito
                        }
                        arraySegundo.unshift(pedidoAceito)
                        setArraySegundo(arraySegundo)
                        setArrayPrimeiro(arrayPrimeiro)

                        if (
                            localStorage.getItem("ultimoImprimir") !== response.data.id &&
                            response.data.imprimir !== false
                        ) {
                            localStorage.setItem("ultimoImprimir", response.data.id)
                            mandarImprimir({
                                pedido: response.data,
                                texto: response.data.texto,
                                qtd: parametros?.viasImpressao,
                                qrcode: verificarPrintQRCode(response.data),
                            })
                        }
                    } else {
                        console.log("QUINTA ELSE")

                        const posicao = buscarIndex(response.data, 1)

                        if (posicao !== -1) {
                            arrayPrimeiro.splice(posicao, 1)
                        }

                        arrayPrimeiro.unshift(response.data)
                        setArrayPrimeiro(arrayPrimeiro)

                        console.log(
                            `01[${response.data.texto}]{${
                                parametros?.viasImpressao ? parametros?.viasImpressao : 1
                            }}`
                        )
                        if (tipoPainelImpressao === "plugin") {
                            if (
                                localStorage.getItem("ultimoImprimir") !== response.data.id &&
                                response.data.imprimir !== false
                            ) {
                                localStorage.setItem("ultimoImprimir", response.data.id)
                                mandarImprimir({
                                    pedido: response.data,
                                    texto: response.data.texto,
                                    qtd: parametros?.viasImpressao,
                                    qrcode: verificarPrintQRCode(response.data),
                                })
                            }
                        }

                        setUseEffect1(!useEffect1)
                        //console.log('depois arrayPrimeiro', arrayPrimeiro)

                        setModalInformacoes(false)
                        setModalInformacoesPedido({})
                        setModalInformacoesPedidoIndex(-1)

                        if (recebedor.prepararPedidoAutomatico) {
                            const i = arrayPrimeiro.indexOf(
                                arrayPrimeiro.find(p => p.id === pedido.id)
                            )

                            if (i !== -1) emProducao(Authorization, pedido, i, true)
                        }
                    }
                })
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "aceitarPedido", { pedido, index })
            alertStart("Erro ao inesperado aceitar pedido", "error")
            setLoading(false)
        }

        setUseEffect1(!useEffect1)
        console.log(pedido.id, "Fim === CONFIRMAÇÃO")
    }

    const cancelarPedido = async (Authorization, pedido, index) => {
        // //console.log('cancelarPedido')
        setLoading(true)
        try {
            let data = {}

            if (pedido.plataforma === "ifood_integracao") {
                data = {
                    observacao: document.getElementById("motivoCancelamentoTexto").value,
                    motivoCancelamentoPedido: listaMotivoCancelamento[motivoCancelamento],
                }
            }
            console.log("DATAAA", data)
            await api
                .post(`integracao/orders/${pedido.id}/statuses/cancellationRequestedV2`, data, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: Authorization,
                        fixed_token_ifood: hashInternaClienteFielIfood,
                        ifood_integration_active: ativaIntegracaoIfood,
                    },
                })
                .then(response => {
                    //console.log(' === cancelarPedido', response)
                    atualizarArraysCancelarPedido(response.data, index, pedido.status)
                    setModalInformacoes(false)
                    setModalInformacoesPedido({})
                    setModalInformacoesPedidoIndex(-1)
                })
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "cancelarPedido", { pedido, index })
            alertStart("Erro ao inesperado cancelarPedido", "error")
            setLoading(false)
        }
    }

    const handleCloseEstabelecimentos = () => {
        const tempoEntregaElements = document.getElementsByClassName("tempoEntrega")
        for (let i = 0; i < tempoEntregaElements.length; i++) {
            const element = tempoEntregaElements[i].firstChild.firstChild

            if (element.value.length > 10) {
                alertStart("Tempo de entrega deve ter um máximo de 10 caracteres", "error")
                return
            }

            atualizarTempoEntregaEstabelecimento(
                element.value,
                estabelecimentos[element.dataset?.indexEstabelecimento],
                element.dataset?.indexEstabelecimento
            )
        }
        setOpenEstabelecimentos(false)
    }

    if (tabStatus === "OFF") {
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#f4f4f4",
                    minHeight: "100vh",
                }}
            >
                <audio
                    src={RingAudio}
                    loop={!configuracoes.recebedor.prepararPedidoAutomatico}
                    id="audiopedido"
                />

                <Row
                    style={{
                        margin: 0,
                        padding: 0,
                    }}
                >
                    <Col
                        xs={12}
                        md={12}
                        lg={12}
                        style={{
                            textAlign: "center",
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: "2rem",
                            }}
                        >
                            Você Foi Desconectado!
                        </Typography>
                        <Typography>
                            Outro computador ou navegador conectou nesse mesmo estabelecimento e
                            você foi desconectado de aceitar pedidos.
                        </Typography>
                    </Col>
                    <Col
                        xs={12}
                        md={12}
                        lg={12}
                        style={{
                            textAlign: "center",
                            margin: 0,
                            padding: 0,
                        }}
                    >
                        <img
                            style={{
                                width: "100%",
                                maxWidth: "600px",
                                maxHeight: "350px",
                            }}
                            src={desconected}
                        />
                    </Col>

                    <Col
                        xs={12}
                        md={4}
                        lg={4}
                        style={{
                            textAlign: "center",
                        }}
                    >
                        <Button
                            variant="contained"
                            color="default"
                            style={{ margin: "5px 0" }}
                            onClick={() => {
                                setTabStatus("CRUD")
                                window.name = ""
                            }}
                        >
                            Conectar Novamente
                        </Button>
                    </Col>

                    <Col
                        xs={12}
                        md={4}
                        lg={4}
                        style={{
                            textAlign: "center",
                        }}
                    >
                        <Button
                            variant="contained"
                            color="default"
                            style={{ background: "#28a745", color: "white", margin: "5px 0" }}
                            onClick={() => {
                                setTabStatus("VIEW")
                            }}
                        >
                            Modo Visualização
                        </Button>
                    </Col>

                    <Col
                        xs={12}
                        md={4}
                        lg={4}
                        style={{
                            textAlign: "center",
                        }}
                    >
                        <Button
                            variant="contained"
                            color="default"
                            style={{ margin: "5px 0" }}
                            onClick={() => {
                                history.push("/servicos")
                            }}
                        >
                            Serviços
                        </Button>
                    </Col>
                </Row>
            </div>
        )
    } else {
        return (
            <Container
                component="main"
                maxWidth="lg"
                className="distanciaTop"
                style={{ minHeight: "120vh" }}
            >
                <Cabecalho pagina={"Recebedor de Pedidos"} avisoDoisRecebedores />

                <Print
                    filaPrints={filaPrints}
                    setFilaPrints={setFilaPrints}
                    mandarImprimir={mandarImprimir}
                />

                <Loading loading={loading} />

                <Snackbar open={alert.status} autoHideDuration={6000} onClose={alertClose}>
                    <Alert onClose={alertClose} severity={alert.tipo}>
                        {alert.mesangem}
                    </Alert>
                </Snackbar>

                <CssBaseline />

                <Dialog
                    open={criarRegistradorModal}
                    fullScreen={true}
                    onClose={() => {
                        criarRegistradorModal(false)
                        setRegistradorModal(false)
                    }}
                >
                    <DialogTitle>
                        <IconButton
                            className="setaVoltarModal"
                            onClick={() => {
                                setCriarRegistradorModal(false)
                                setRegistradorModal(false)
                            }}
                        >
                            <ArrowForwardIosIcon />
                        </IconButton>
                        Registrador de Pedidos
                    </DialogTitle>
                    <DialogContent
                        style={{
                            padding: "0",
                            overflowY: "none",
                        }}
                    >
                        <iframe
                            style={{
                                height: "100%",
                                width: "100%",
                            }}
                            src={
                                "https://" +
                                window.location.host +
                                "/servicos/modulo/registrador-de-pedidos"
                            }
                        />
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={contratar}
                    onClose={() => {
                        setContratar(false)
                    }}
                >
                    <DialogTitle>{"Contato para Contratar"}</DialogTitle>
                    <DialogContent>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Button
                                    onClick={() => {
                                        window.open(
                                            "https://api.whatsapp.com/send?phone=5531994754366&text=Oi%20tudo%20bem?%20Gostaria%20de%20saber%20como%20funciona%20o%20registrador%20de%20pedidos%20para%20contratar.",
                                            "_blank"
                                        )
                                        setContratar(false)
                                    }}
                                    style={{ backgroundColor: "#075E54", color: "white" }}
                                    fullWidth
                                    variant="contained"
                                >
                                    Contactar por Whatsapp
                                </Button>
                            </Col>
                            <Col xs={12} md={12} lg={12}>
                                <Button
                                    onClick={() => {
                                        setContratar(false)
                                    }}
                                    fullWidth
                                    style={{ marginTop: "1em" }}
                                >
                                    Não quero
                                </Button>
                            </Col>
                        </Row>
                    </DialogContent>
                </Dialog>

                {tabStatus === "VIEW" ? (
                    <Row style={{ width: "100%", margin: "0" }}>
                        <AlertFixo
                            severity="warning"
                            style={{ width: "100%", marginBottom: "1em" }}
                        >
                            Você está conectado em <b>modo visualização</b> (não é possivel aceitar
                            pedidos)
                            <Button
                                color="default"
                                // style={{"background": "#28a745", "color":"white"}}
                                onClick={() => {
                                    setTabStatus("CRUD")
                                    window.name = ""
                                }}
                            >
                                Conectar Modo Aceitar Pedidos
                            </Button>
                        </AlertFixo>
                    </Row>
                ) : null}

                <Row>
                    <Col xs={12} md={3} lg={3}>
                        <TextField
                            style={{ background: "#fff" }}
                            id="procurar-pedido-alteranativo"
                            onChange={e => {
                                procurarPedido(e, arrayTodosPedidos)
                            }}
                            fullWidth
                            label="Procurar"
                            variant="outlined"
                        />
                    </Col>
                    <Col xs={12} md={9} lg={9} className="text-right">
                        {!(
                            !configuracoes.user?.parametros?.possuiIntegracaoUber &&
                            !configuracoes.user?.parametros?.ativaIntegracaoIfood
                        ) && (
                            <BotaoIntegracoes
                                setExpandListaIntegracoes={setExpandListaIntegracoes}
                                expandListaIntegracoes={expandListaIntegracoes}
                            />
                        )}

                        {/* {parametros?.ativaIntegracaoIfood &&
              <Button size="small" className="opcaoTop mx-2" onClick={() => { setModalIfoodConfig(true) }}  >
                <Col xs={12} md={12} lg={12} className="text-center">
                  <Row>
                    <img src={iconIfood} style={{ width: '100px', height: '50px' }} alt="iFood Integração" />
                  </Row>
                  <Row className="text-center">
                    <span>{statusLojaIfood?.title}</span>
                  </Row>
                  <Row className="text-center">
                    <span>{statusLojaIfood?.message}</span>
                  </Row>
                </Col>
              </Button>
            } */}

                        <Button
                            size="small"
                            className="opcaoTop mx-2"
                            onClick={() => {
                                window.setTimeout(function () {
                                    setCriarRegistradorModal(true)
                                    handleRegistradorDePedidos(() => setRegistradorModal(true))
                                }, 1000)
                            }}
                        >
                            <EditIcon style={{ margin: "0 5px 0 0" }} />
                            <span className="none-mobile">Registrador</span>
                        </Button>

                        <Button
                            size="small"
                            className="opcaoTop mx-2"
                            onClick={handleBuscarDadosEstabelecimentos}
                        >
                            <HomeWorkIcon style={{ margin: "0 5px 0 0" }} />
                            <span className="none-mobile">Estabelecimentos</span>
                        </Button>

                        {configuracoes?.user?.perfil !== "DELIVERY_BASICO" && (
                            <Button size="small" className="opcaoTop mx-2" onClick={resumoDoDia}>
                                <ReceiptIcon style={{ margin: "0 5px 0 0" }} />
                                <span className="none-mobile">Resumo</span>
                            </Button>
                        )}

                        <Button size="small" onClick={atualizar} className="opcaoTop mx-2">
                            <RefreshIcon style={{ margin: "0 5px 0 0" }} />
                            <Segundos
                                parametros={parametros}
                                recebedor={recebedor}
                                tabStatus={tabStatus}
                                buscarTodosPedidos={buscarTodosPedidos}
                            />
                        </Button>

                        <Button
                            size="small"
                            onClick={() => {
                                setModalConfiguracoes(true)
                            }}
                            className="opcaoTop mx-2"
                        >
                            <SettingsIcon style={{ margin: "0 5px 0 0" }} />
                        </Button>
                    </Col>
                </Row>
                <Row>
                    {recebedor.prepararPedidoAutomatico != true ? (
                        <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                            <Lista
                                tipoPainelImpressao={tipoPainelImpressao}
                                indexLista={1}
                                mostrar={mostrarPrimeiro}
                                procurarMotoqueiros={procurarMotoqueiros}
                                solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                                buscarStatus={buscarStatus}
                                loading={loadingPedidos}
                                array={arrayPrimeiro}
                                classes={classes}
                                autorizacao={autorizacao}
                                impressorasQZ={impressorasQZ}
                                mandarImprimir={mandarImprimir}
                                setModalInformacoes={setModalInformacoes}
                                setModalInformacoesPedido={setModalInformacoesPedido}
                                setModalInformacoesPedidoIndex={setModalInformacoesPedidoIndex}
                                tabStatus={tabStatus}
                                mudarStatusPara={mudarStatusPara}
                            />
                        </Col>
                    ) : null}

                    <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                        <Lista
                            tipoPainelImpressao={tipoPainelImpressao}
                            indexLista={2}
                            mostrar={mostrarSegundo}
                            loading={loadingPedidos}
                            array={arraySegundo}
                            procurarMotoqueiros={procurarMotoqueiros}
                            solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                            buscarStatus={buscarStatus}
                            configuracoes={configuracoes}
                            classes={classes}
                            autorizacao={autorizacao}
                            impressorasQZ={impressorasQZ}
                            mandarImprimir={mandarImprimir}
                            setModalInformacoes={setModalInformacoes}
                            setModalInformacoesPedido={setModalInformacoesPedido}
                            setModalInformacoesPedidoIndex={setModalInformacoesPedidoIndex}
                            tabStatus={tabStatus}
                            mudarStatusPara={mudarStatusPara}
                        />
                    </Col>

                    <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                        <Lista
                            tipoPainelImpressao={tipoPainelImpressao}
                            indexLista={3}
                            mostrar={mostrarTerceiro}
                            solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                            procurarMotoqueiros={procurarMotoqueiros}
                            buscarStatus={buscarStatus}
                            loading={loadingPedidos}
                            array={arrayTerceiro}
                            configuracoes={configuracoes}
                            classes={classes}
                            autorizacao={autorizacao}
                            impressorasQZ={impressorasQZ}
                            mandarImprimir={mandarImprimir}
                            setModalInformacoes={setModalInformacoes}
                            setModalInformacoesPedido={setModalInformacoesPedido}
                            setModalInformacoesPedidoIndex={setModalInformacoesPedidoIndex}
                            tabStatus={tabStatus}
                            mudarStatusPara={mudarStatusPara}
                        />
                    </Col>

                    <Col xs={12} md={tamanhoLista} lg={tamanhoLista}>
                        <Lista
                            tipoPainelImpressao={tipoPainelImpressao}
                            indexLista={4}
                            mostrar={mostrarQuarto}
                            procurarMotoqueiros={procurarMotoqueiros}
                            solicitarEntregaFuiDelivery={solicitarEntregaFuiDelivery}
                            buscarStatus={buscarStatus}
                            loading={loadingPedidos}
                            array={arrayQuarto}
                            configuracoes={configuracoes}
                            classes={classes}
                            autorizacao={autorizacao}
                            impressorasQZ={impressorasQZ}
                            mandarImprimir={mandarImprimir}
                            setModalInformacoes={setModalInformacoes}
                            setModalInformacoesPedido={setModalInformacoesPedido}
                            setModalInformacoesPedidoIndex={setModalInformacoesPedidoIndex}
                            tabStatus={tabStatus}
                            mudarStatusPara={mudarStatusPara}
                        />
                    </Col>

                    <Dialog
                        open={confirmacaoCancelado.length ? true : false}
                        onClose={() => {
                            setConfirmacaoCancelado([])
                        }}
                    >
                        <DialogTitle>{"Confirmação"}</DialogTitle>
                        <DialogContent>
                            <Row>
                                {confirmacaoCancelado[1]?.plataforma === "ifood_integracao" ? (
                                    <>
                                        <Col xs={12} md={12} lg={12}>
                                            <FormControl
                                                variant="outlined"
                                                className={classes.formControl}
                                            >
                                                <InputLabel htmlFor="outlined-age-native-simple">
                                                    Motivo
                                                </InputLabel>
                                                <Select
                                                    native
                                                    fullWidth
                                                    value={motivoCancelamento}
                                                    onChange={event => {
                                                        setMotivoCancelamento(event.target.value)
                                                    }}
                                                    label="Motivo"
                                                    inputProps={{
                                                        name: "age",
                                                        id: "outlined-age-native-simple",
                                                    }}
                                                >
                                                    {listaMotivoCancelamento.map(
                                                        (motivo, index) => (
                                                            <option value={index}>
                                                                {motivo.description}
                                                            </option>
                                                        )
                                                    )}
                                                </Select>
                                            </FormControl>
                                        </Col>
                                        <Col
                                            xs={12}
                                            md={12}
                                            lg={12}
                                            className="motivoCancelamentoTexto"
                                        >
                                            <TextField
                                                id="motivoCancelamentoTexto"
                                                label="Observação"
                                                multiline
                                                fullWidth
                                                rows={4}
                                                variant="outlined"
                                            />
                                        </Col>
                                    </>
                                ) : null}
                                <Col xs={12} md={12} lg={12}>
                                    <Button
                                        onClick={() => {
                                            setConfirmacaoCancelado([])
                                        }}
                                        fullWidth
                                        variant="contained"
                                    >
                                        NÃO CANCELAR
                                    </Button>
                                </Col>
                                <Col xs={12} md={12} lg={12}>
                                    <Button
                                        onClick={() => {
                                            cancelarPedido(
                                                confirmacaoCancelado[0],
                                                confirmacaoCancelado[1],
                                                confirmacaoCancelado[2]
                                            )
                                            setConfirmacaoCancelado([])
                                        }}
                                        fullWidth
                                        style={{
                                            marginTop: "1em",
                                            backgroundColor: "#dc3545",
                                            color: "white",
                                        }}
                                    >
                                        CANCELAR
                                    </Button>
                                </Col>
                            </Row>
                        </DialogContent>
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalSearchPedido}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setModalSearchPedido(false)
                        }}
                    >
                        <DialogTitle>{"Procurar Pedido"}</DialogTitle>
                        <DialogContent>
                            <Row>
                                <Col xs={12} md={12} lg={12}>
                                    <TextField
                                        id="procurar-pedido"
                                        onChange={e => {
                                            procurarPedido(e, arrayTodosPedidos, false)
                                        }}
                                        fullWidth
                                        label="Procurar"
                                        variant="outlined"
                                    />
                                </Col>

                                {modalSearchPedido && todosPedidos().length === 0 ? (
                                    <Col xs={12} md={12} lg={12} style={{ marginTop: "1em" }}>
                                        <Typography>Você ainda não recebeu pedidos hoje</Typography>
                                    </Col>
                                ) : (
                                    <React.Fragment>
                                        <Col xs={12} md={12} lg={12} style={{ marginTop: "1em" }}>
                                            <Typography>
                                                Total de {todosPedidos().length} pedidos
                                            </Typography>
                                        </Col>
                                        <Col xs={12} md={12} lg={12}>
                                            <List
                                                className={classes.rootList}
                                                style={{ textAlign: "center" }}
                                            >
                                                {todosPedidos().map((pedido, index) => (
                                                    <ListItem
                                                        button
                                                        key={pedido?.id}
                                                        id={`pedido-${pedido?.id}`}
                                                        onClick={e => {
                                                            setModalInformacoesPedido(pedido)
                                                            setModalInformacoesPedidoIndex(index)
                                                            setModalInformacoes(true)
                                                        }}
                                                    >
                                                        <ListItemAvatar>
                                                            {pedido.type === "1" ? (
                                                                <Avatar className="retirada-buscar">
                                                                    <DirectionsWalkIcon />
                                                                </Avatar>
                                                            ) : /**pedido.mesa */ pedido.type ===
                                                              "2" ? (
                                                                <Avatar className="pedido-mesa">
                                                                    <AirlineSeatReclineNormalIcon />
                                                                </Avatar>
                                                            ) : (
                                                                <Avatar className="delivery-entrega">
                                                                    <MotorcycleIcon />
                                                                </Avatar>
                                                            )}
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={
                                                                <React.Fragment>
                                                                    {
                                                                        <Typography
                                                                            component="span"
                                                                            variant="body2"
                                                                            color="textPrimary"
                                                                        >
                                                                            {pedido?.type ===
                                                                            "1" ? (
                                                                                <DirectionsWalkIcon className="tipoEntrega" />
                                                                            ) : pedido?.type ===
                                                                              "2" ? ( //pedido.mesa
                                                                                <AirlineSeatReclineNormalIcon className="tipoEntrega" />
                                                                            ) : (
                                                                                <MotorcycleIcon className="tipoEntrega" />
                                                                            )}{" "}
                                                                            #{pedido?.id} - Hora:{" "}
                                                                            {(pedido?.createdAt).substring(
                                                                                pedido?.createdAt.indexOf(
                                                                                    " "
                                                                                )
                                                                            )}
                                                                        </Typography>
                                                                    }
                                                                    <Typography
                                                                        component="h2"
                                                                        color="textPrimary"
                                                                        className="text-capitalize"
                                                                    >
                                                                        {pedido?.customer.name}
                                                                    </Typography>
                                                                </React.Fragment>
                                                            }
                                                            secondary={
                                                                <>
                                                                    <Typography
                                                                        component="span"
                                                                        variant="body2"
                                                                        className={classes.inline}
                                                                        color="textPrimary"
                                                                    >
                                                                        {
                                                                            // CANCELADO_PELO_DISTRIBUIDOR = -1;
                                                                            // CANCELADO_PELO_CLIENTE = -2;
                                                                            // NAO_ENTREGUE = -3;
                                                                            // EXPIRADO = -4;
                                                                            // CHARGEBACK = -10;
                                                                            pedido?.status < 0 ? (
                                                                                <span className="statusQuartoVermelho">
                                                                                    {buscarStatus(
                                                                                        pedido
                                                                                    )}
                                                                                </span>
                                                                            ) : (
                                                                                <span className="statusQuarto">
                                                                                    {buscarStatus(
                                                                                        pedido
                                                                                    )}
                                                                                </span>
                                                                            )
                                                                        }
                                                                    </Typography>
                                                                    {" — " + pedido?.payments.name}
                                                                </>
                                                            }
                                                        />
                                                        {Intl.NumberFormat("pt-BR", {
                                                            style: "currency",
                                                            currency: "BRL",
                                                        }).format(pedido?.totalPrice)}
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Col>
                                    </React.Fragment>
                                )}
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    setModalSearchPedido(false)
                                }}
                            >
                                voltar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalIfoodConfig}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setModalIfoodConfig(false)
                        }}
                    >
                        <DialogTitle>{"Dados iFood"}</DialogTitle>
                        <DialogContent>
                            <Col
                                xs={12}
                                md={12}
                                lg={12}
                                style={{ marginBottom: "1em", textAlign: "center" }}
                            >
                                <Typography>
                                    {statusLojaIfood?.title
                                        ? statusLojaIfood?.title
                                        : "--- Sem informações ---"}
                                </Typography>

                                <Typography>{statusLojaIfood?.message}</Typography>
                            </Col>

                            {statusLojaIfood?.extraInfo?.map((info, index) => (
                                <Col
                                    key={index}
                                    xs={12}
                                    md={12}
                                    lg={12}
                                    style={{ marginBottom: "1em", textAlign: "center" }}
                                >
                                    <Typography>{info ? " * " + info : "---"}</Typography>
                                </Col>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    setModalIfoodConfig(false)
                                }}
                            >
                                Voltar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalConfiguracoes}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setModalConfiguracoes(false)
                            if (mudancaConfiguracao) {
                                atualizar(true)
                                setMudancaConfiguracao(false)
                            }
                        }}
                    >
                        <DialogTitle>{"Configurações"}</DialogTitle>

                        <DialogContent>
                            <Row>
                                <Col xs={12} style={{ margin: "0.5em 0", textAlign: "center" }}>
                                    {/* <img src={RECEBEDOR_ICON} style={{"width": '70px', "height": '70px'}}/> */}
                                    <img
                                        src={
                                            configuracoes.user?.parametros.estabelecimento?.urlLogo
                                                ? configuracoes.user?.parametros.estabelecimento
                                                      ?.urlLogo
                                                : aplicativoDados.urlLogo
                                        }
                                        style={{ width: "70px", height: "70px" }}
                                        alt=""
                                    />
                                </Col>

                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <TextField
                                        id="att-automatico-todos-pedidos"
                                        defaultValue={recebedor.buscarAutomaticamenteXSegundos}
                                        onChange={e => {
                                            if (e.target.value >= 60 || e.target.value <= 0) {
                                                var valor = e.target.value
                                                if (e.target.value <= 0) {
                                                    valor = 180
                                                    alertStart(
                                                        `Atualização automatica configurada a cada ${180} segundos!`,
                                                        "success"
                                                    )
                                                } else {
                                                    alertStart(
                                                        `Atualização automatica configurada a cada ${valor} segundos!`,
                                                        "success"
                                                    )
                                                }
                                                const tmp = JSON.parse(
                                                    JSON.stringify(configuracoes)
                                                )
                                                tmp.recebedor.buscarAutomaticamenteXSegundos = valor
                                                atualizarConfiguracoes(tmp)
                                                setMudancaConfiguracao(true)
                                            } else {
                                                alertStart(
                                                    "Para atualizar automatico necessário tempo acima de 60 segundos!",
                                                    "error"
                                                )
                                            }
                                        }}
                                        fullWidth
                                        placeholder={"120"}
                                        label="Atualizar em Segundos"
                                        variant="outlined"
                                    />
                                </Col>

                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <TextField
                                        id="exibicao-pedidos-maximo"
                                        defaultValue={recebedor.exibicaoMaxima}
                                        onChange={e => {
                                            if (e.target.value >= 10) {
                                                var valor = e.target.value
                                                const tmp = JSON.parse(
                                                    JSON.stringify(configuracoes)
                                                )
                                                tmp.recebedor.exibicaoMaxima = valor
                                                atualizarConfiguracoes(tmp)
                                                setMudancaConfiguracao(true)
                                            } else {
                                                alertStart(
                                                    `A exibição mínima é de 10 pedidos`,
                                                    "error"
                                                )
                                            }
                                        }}
                                        fullWidth
                                        placeholder={"30"}
                                        label="Exibicação Máxima de Pedidos"
                                        variant="outlined"
                                    />
                                </Col>

                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <TextField
                                        disabled
                                        id="quantidade-vias"
                                        defaultValue={parametros.viasImpressao}
                                        fullWidth
                                        label="Quantidade de Vias"
                                        variant="outlined"
                                    />
                                </Col>

                                <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                    <React.Fragment>
                                        <FormControl
                                            variant="outlined"
                                            className={classes.formControl}
                                            style={{ width: "100%" }}
                                        >
                                            <InputLabel id="tipopainel">
                                                Painel com Impressão
                                            </InputLabel>
                                            <Select
                                                fullWidth
                                                value={tipoPainelImpressao}
                                                disabled
                                                label="Painel com Impressão"
                                            >
                                                <MenuItem value="navegador">
                                                    Navegador Nativo
                                                </MenuItem>
                                                <MenuItem value={"plugin"}>Plugin QZ</MenuItem>
                                                <MenuItem value={"software"}>Software EXE</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </React.Fragment>
                                </Col>

                                {exibirSeletorTamanho ? (
                                    <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                        <React.Fragment>
                                            <FormControl
                                                variant="outlined"
                                                className={classes.formControl}
                                                style={{ width: "100%" }}
                                            >
                                                <InputLabel id="impressoras">
                                                    Tamanho da Fonte
                                                </InputLabel>
                                                <Select
                                                    fullWidth
                                                    value={tamanhoFonteSelect}
                                                    onChange={e => {
                                                        const tmp = JSON.parse(
                                                            JSON.stringify(configuracoes)
                                                        )
                                                        tmp.printer.tamanhoFonteSelect =
                                                            e.target.value
                                                        atualizarConfiguracoes(tmp)
                                                    }}
                                                    label="Tamanho da Fonte"
                                                >
                                                    <MenuItem value="pequena">
                                                        <em>Pequena</em>
                                                    </MenuItem>

                                                    <MenuItem value="media">
                                                        <em>Media</em>
                                                    </MenuItem>

                                                    <MenuItem value="grande">
                                                        <em>Grande</em>
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </React.Fragment>
                                    </Col>
                                ) : null}

                                {tipoPainelImpressao === "plugin" &&
                                    tipoPainelImpressao !== "software" &&
                                    exibirTamanhoFonte && (
                                        <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                            <TextField
                                                id="tamanho-font"
                                                value={printer.tamanhoFonteImpressao}
                                                onChange={e => {
                                                    // if(e.target.value >= 10 && e.target.value <= 30){
                                                    var valor = e.target.value
                                                    // document.getElementsByTagName('HTML')[0].style.fontSize = `${valor}%`

                                                    const tmp = JSON.parse(
                                                        JSON.stringify(configuracoes)
                                                    )
                                                    tmp.printer.tamanhoFonteImpressao = valor
                                                    atualizarConfiguracoes(tmp)
                                                    setMudancaConfiguracao(true)
                                                    // }
                                                }}
                                                fullWidth
                                                placeholder={"14"}
                                                type={"number"}
                                                label="Tamanho Fonte Impressão"
                                                variant="outlined"
                                            />
                                        </Col>
                                    )}

                                {!mobile &&
                                tabStatus === "CRUD" &&
                                tipoPainelImpressao !== "software" ? (
                                    <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                        {tipoPainelImpressao === "plugin" ? (
                                            <React.Fragment>
                                                <FormControl
                                                    variant="outlined"
                                                    className={classes.formControl}
                                                    style={{ width: "100%" }}
                                                >
                                                    <InputLabel id="impressoras">
                                                        Imprimir 1º Opção
                                                    </InputLabel>
                                                    <Select
                                                        fullWidth
                                                        defaultValue={
                                                            printer.impressora
                                                                ? printer.impressora
                                                                : "vazio"
                                                        }
                                                        onChange={e => {
                                                            const config = configuracoes
                                                            config.printer.impressora =
                                                                e.target.value
                                                            atualizarConfiguracoes(config)
                                                        }}
                                                        label="Impressora P/ Imprimir"
                                                    >
                                                        <MenuItem value="vazio">
                                                            <em>Nenhuma</em>
                                                        </MenuItem>

                                                        {impressorasQZ.map((printer, index) => (
                                                            <MenuItem key={index} value={printer}>
                                                                {printer}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </React.Fragment>
                                        ) : null}
                                    </Col>
                                ) : null}

                                {!mobile &&
                                tabStatus === "CRUD" &&
                                tipoPainelImpressao !== "software" ? (
                                    <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                        {tipoPainelImpressao === "plugin" ? (
                                            <React.Fragment>
                                                <FormControl
                                                    variant="outlined"
                                                    className={classes.formControl}
                                                    style={{ width: "100%" }}
                                                >
                                                    <InputLabel id="impressoras">
                                                        Imprimir 2º Opção
                                                    </InputLabel>
                                                    <Select
                                                        fullWidth
                                                        // labelId="Impressora-P-Imprimir-2"
                                                        // id="Impressora-P-Imprimir-2"
                                                        defaultValue={
                                                            printer.impressora2
                                                                ? printer.impressora2
                                                                : "vazio"
                                                        }
                                                        // value={}
                                                        onChange={e => {
                                                            // const config = configuracoes
                                                            // config.impressora2 = e.target.value
                                                            // localStorage.setItem('configuracoes', JSON.stringify(config));
                                                            // // setMudancaConfiguracao(true)
                                                            // atualizarConfiguracoes(config)

                                                            const tmp = JSON.parse(
                                                                JSON.stringify(configuracoes)
                                                            )
                                                            tmp.printer.impressora2 = e.target.value
                                                            atualizarConfiguracoes(tmp)
                                                        }}
                                                        label="Imprimir 2º Opção"
                                                    >
                                                        <MenuItem value="vazio">
                                                            <em>Nenhuma</em>
                                                        </MenuItem>

                                                        {impressorasQZ.map((printer, index) => (
                                                            <MenuItem key={index} value={printer}>
                                                                {printer}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </React.Fragment>
                                        ) : null}
                                    </Col>
                                ) : null}

                                {tipoPainelImpressao === "navegador" ? (
                                    <Col xs={12} md={6} lg={6} style={{ margin: "0.2em 0 1em 0" }}>
                                        <Button
                                            onClick={e => {
                                                window.open(
                                                    "https://ajuda.clientefiel.app/painel-cliente-fiel/ferramentas/formas-de-impressao",
                                                    "_blank"
                                                )
                                            }}
                                            variant="contained"
                                            style={{ backgroundColor: "#6c757d", color: "white" }}
                                        >
                                            Imprimir Comanda Automaticamente
                                        </Button>
                                    </Col>
                                ) : null}

                                {!mobile &&
                                tabStatus === "CRUD" &&
                                tipoPainelImpressao !== "software" ? (
                                    <Col xs={12} md={6} lg={6} style={{ margin: "0.5em 0" }}>
                                        {tipoPainelImpressao === "plugin" ? (
                                            <React.Fragment>
                                                <FormControl
                                                    variant="outlined"
                                                    className={classes.formControl}
                                                    style={{ width: "100%" }}
                                                >
                                                    <InputLabel id="impressoras">
                                                        Tipo Printer Cliente Fiel
                                                    </InputLabel>
                                                    <Select
                                                        fullWidth
                                                        labelId="tipoImpressao"
                                                        id="tipoImpressao"
                                                        value={tipoPrinter}
                                                        // value={}
                                                        onChange={e => {
                                                            const tmp = JSON.parse(
                                                                JSON.stringify(configuracoes)
                                                            )
                                                            tmp.printer.tipoImpressao =
                                                                e.target.value
                                                            atualizarConfiguracoes(tmp)
                                                        }}
                                                        label="Tipo Printer Cliente Fiel"
                                                    >
                                                        <MenuItem value="code">
                                                            <em>Tipo CODE</em>
                                                        </MenuItem>

                                                        <MenuItem value="html">
                                                            <em>Tipo HTML</em>
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </React.Fragment>
                                        ) : null}
                                    </Col>
                                ) : null}

                                {!mobile && tabStatus === "CRUD" ? (
                                    <Col xs={12} md={12} lg={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    defaultChecked={
                                                        recebedor.aceitarPedidoAutomatico
                                                    }
                                                    onChange={e => {
                                                        recebedor.aceitarPedidoAutomatico =
                                                            e.target.checked
                                                        if (!e.target.checked) {
                                                            recebedor.prepararPedidoAutomatico =
                                                                e.target.checked
                                                        }
                                                        atualizarConfiguracoes(configuracoes)
                                                        setMudancaConfiguracao(true)
                                                    }}
                                                    icon={
                                                        <CheckBoxOutlineBlankIcon fontSize="small" />
                                                    }
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    name="aceite-automatico"
                                                />
                                            }
                                            label="Aceitar Automaticamente os Pedidos"
                                        />
                                    </Col>
                                ) : null}

                                {!mobile &&
                                    tabStatus === "CRUD" &&
                                    recebedor.aceitarPedidoAutomatico && (
                                        <>
                                            <Col xs={12} md={12} lg={12}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            defaultChecked={
                                                                recebedor.prepararPedidoAutomatico
                                                            }
                                                            onChange={e => {
                                                                recebedor.prepararPedidoAutomatico =
                                                                    e.target.checked
                                                                atualizarConfiguracoes(
                                                                    configuracoes
                                                                )
                                                                setMudancaConfiguracao(true)
                                                            }}
                                                            icon={
                                                                <CheckBoxOutlineBlankIcon fontSize="small" />
                                                            }
                                                            checkedIcon={
                                                                <CheckBoxIcon fontSize="small" />
                                                            }
                                                            name="preparar-automatico"
                                                        />
                                                    }
                                                    label="Preparar Automaticamente os Pedidos"
                                                />
                                            </Col>
                                            {tipoPainelImpressao === "navegador" && (
                                                <Col xs={12} md={12} lg={12}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                defaultChecked={
                                                                    recebedor.imprimirPedidoAutomatico
                                                                }
                                                                onChange={e => {
                                                                    recebedor.imprimirPedidoAutomatico =
                                                                        e.target.checked
                                                                    atualizarConfiguracoes(
                                                                        configuracoes
                                                                    )
                                                                    setMudancaConfiguracao(true)
                                                                }}
                                                                icon={
                                                                    <CheckBoxOutlineBlankIcon fontSize="small" />
                                                                }
                                                                checkedIcon={
                                                                    <CheckBoxIcon fontSize="small" />
                                                                }
                                                                name="imprimir-automatico"
                                                            />
                                                        }
                                                        label="Imprimir Automaticamente os Pedidos"
                                                    />
                                                </Col>
                                            )}
                                        </>
                                    )}

                                {!mobile && tabStatus === "CRUD" && false ? (
                                    <Col xs={12} md={12} lg={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    defaultChecked={recebedor.alertaTempoEntrega}
                                                    onChange={e => {
                                                        recebedor.alertaTempoEntrega =
                                                            e.target.checked
                                                        atualizarConfiguracoes(configuracoes)
                                                        setMudancaConfiguracao(true)
                                                    }}
                                                    icon={
                                                        <CheckBoxOutlineBlankIcon fontSize="small" />
                                                    }
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    name="preparar-automatico"
                                                />
                                            }
                                            label="Alertar que o pedido está atrasado"
                                        />
                                    </Col>
                                ) : null}

                                <Col xs={12} md={12} lg={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={recebedor.efeitoSonoro}
                                                onChange={e => {
                                                    // //console.log(e.target.checked)
                                                    recebedor.efeitoSonoro = e.target.checked
                                                    atualizarConfiguracoes(configuracoes)
                                                    setMudancaConfiguracao(true)

                                                    window.setCookie(
                                                        "efeito-sonoro-ativo",
                                                        e.target.checked,
                                                        9999
                                                    )
                                                }}
                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                name="efeito-sonoro"
                                            />
                                        }
                                        label="Efeito Sonoro"
                                    />
                                    <TextField
                                        size="small"
                                        variant="outlined"
                                        value={recebedor.duracaoEfeitoSonoro}
                                        label="Duração"
                                        disabled={!recebedor.efeitoSonoro}
                                        style={{ maxWidth: "5.5rem" }}
                                        onChange={e => {
                                            recebedor.duracaoEfeitoSonoro = e.target.value.replace(
                                                /\D/g,
                                                ""
                                            )
                                            atualizarConfiguracoes(configuracoes)
                                            setMudancaConfiguracao(true)
                                        }}
                                    />
                                </Col>

                                {exibirImprimirLogo ? (
                                    <Col xs={12} md={12} lg={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    defaultChecked={printer.imprimirLogo}
                                                    onChange={e => {
                                                        const tmp = JSON.parse(
                                                            JSON.stringify(configuracoes)
                                                        )
                                                        tmp.printer.imprimirLogo = e.target.checked
                                                        atualizarConfiguracoes(tmp)
                                                    }}
                                                    icon={
                                                        <CheckBoxOutlineBlankIcon fontSize="small" />
                                                    }
                                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                    name="imprimir-logo"
                                                />
                                            }
                                            label="Imprimir logo"
                                        />
                                    </Col>
                                ) : null}

                                <Col xs={12} md={6} lg={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                defaultChecked={recebedor.mostrarEndereco}
                                                onChange={e => {
                                                    // //console.log(e.target.checked)
                                                    recebedor.mostrarEndereco = e.target.checked
                                                    atualizarConfiguracoes(configuracoes)
                                                    setMudancaConfiguracao(true)
                                                }}
                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                name="mostrar-endereco"
                                            />
                                        }
                                        label="Mostrar Endereço"
                                    />
                                </Col>
                                <Col xs={12} md={6} lg={6}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                defaultChecked={recebedor.mostrarEntregador}
                                                onChange={e => {
                                                    // //console.log(e.target.checked)
                                                    recebedor.mostrarEntregador = e.target.checked
                                                    atualizarConfiguracoes(configuracoes)
                                                    setMudancaConfiguracao(true)
                                                }}
                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                name="mostrar-entregador"
                                            />
                                        }
                                        label="Mostrar Entregador"
                                    />
                                </Col>
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    setModalConfiguracoes(false)
                                    if (mudancaConfiguracao) {
                                        atualizar(true)
                                        setMudancaConfiguracao(false)
                                    }
                                }}
                            >
                                Voltar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={openEstabelecimentos}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={handleCloseEstabelecimentos}
                    >
                        <DialogTitle>{"Configurações dos Estabelecimentos"}</DialogTitle>
                        <DialogContent>
                            {estabelecimentos.map((estabelecimento, index) => (
                                <Row key={index}>
                                    <Col
                                        xs={12}
                                        md={12}
                                        lg={12}
                                        style={{ marginBottom: "1em", textAlign: "center" }}
                                    >
                                        <Typography>{estabelecimento.nome}</Typography>
                                    </Col>
                                    <Col xs={12} md={6} lg={6} style={{ marginBottom: "1em" }}>
                                        <FormControl
                                            variant="outlined"
                                            className={classes.formControl}
                                            fullWidth
                                        >
                                            <InputLabel htmlFor="outlined-age-native-simple">
                                                Status
                                            </InputLabel>
                                            <Select
                                                native
                                                value={
                                                    estabelecimento.situacao === 1 &&
                                                    estabelecimento.pausado
                                                        ? 2
                                                        : estabelecimento.situacao
                                                }
                                                fullWidth
                                                label="Status"
                                                style={{ padding: 0 }}
                                                onChange={e => {
                                                    atualizarStatusEstabelecimento(
                                                        e,
                                                        estabelecimento,
                                                        index
                                                    )
                                                }}
                                                endAdornment={
                                                    <InputAdornment
                                                        style={{
                                                            position: "absolute",
                                                            left: "15px",
                                                        }}
                                                    >
                                                        {estabelecimento.situacao === 1 &&
                                                        estabelecimento.pausado ? (
                                                            <PauseCircleFilledIcon
                                                                style={{ color: "#ffc107" }}
                                                            />
                                                        ) : estabelecimento.situacao === 0 ? (
                                                            <CancelIcon
                                                                style={{ color: "#dc3545" }}
                                                            />
                                                        ) : (
                                                            <PlayCircleFilledIcon
                                                                style={{ color: "#28a745" }}
                                                            />
                                                        )}
                                                    </InputAdornment>
                                                }
                                                inputProps={{
                                                    name: "Status",
                                                    id: "select-status-estabelecimento",
                                                }}
                                            >
                                                <option value={1}>Aberto</option>
                                                <option value={0}>Fechado</option>
                                                <option value={2}>Pausado</option>
                                            </Select>
                                        </FormControl>
                                    </Col>
                                    <Col xs={12} md={6} lg={6}>
                                        <TextField
                                            className="tempoEntrega"
                                            variant="outlined"
                                            placeholder="Tempo de entrega"
                                            helperText="Exemplo: 45-60 min"
                                            defaultValue={estabelecimento.tempoEntregaTexto}
                                            inputProps={{
                                                "data-index-estabelecimento": index,
                                            }}
                                        />
                                    </Col>
                                    <Divider className={"divisaoEstabelecimentos"}></Divider>
                                </Row>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseEstabelecimentos}>Voltar</Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalMotoqueiro}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setModalMotoqueiro(false)
                        }}
                    >
                        <DialogTitle>{"Entregadores Cadastrados"}</DialogTitle>
                        <DialogContent>
                            <Row>
                                {motoqueiroSelecionadoPedido[0].plataforma ===
                                "ifood_integracao" ? (
                                    <AlertFixo
                                        severity="warning"
                                        style={{ width: "100%", marginBottom: "1em" }}
                                    >
                                        Esse é um pedido <b>IFOOD</b>, selecione apenas se realmente
                                        você for entregar com motoqueiro próprio.
                                    </AlertFixo>
                                ) : null}
                            </Row>
                            <Row>
                                {loadingMotoqueiro || loadingSalvarMotoqueiro ? (
                                    <React.Fragment>
                                        <Col
                                            xs={12}
                                            md={12}
                                            lg={12}
                                            style={{ textAlign: "center" }}
                                        >
                                            <CircularProgress color="inherit" />
                                        </Col>
                                        <Col
                                            xs={12}
                                            md={12}
                                            lg={12}
                                            style={{ textAlign: "center" }}
                                        >
                                            <Typography>
                                                {loadingSalvarMotoqueiro
                                                    ? "Salvando Entregador"
                                                    : "Carregando Entregadores"}
                                            </Typography>
                                        </Col>
                                    </React.Fragment>
                                ) : motoqueiros.length > 0 ? (
                                    <Col xs={12} md={12} lg={12}>
                                        <FormControl component="fieldset">
                                            {/* <FormLabel component="legend">Motoqueiros</FormLabel> */}
                                            <RadioGroup
                                                value={motoqueiroSelecionado}
                                                onChange={selecionarMotoqueiro}
                                            >
                                                {motoqueiros.map((motoqueiro, index) => (
                                                    <FormControlLabel
                                                        key={index}
                                                        value={"#" + motoqueiro.identifier}
                                                        control={<Radio />}
                                                        label={
                                                            motoqueiro.nome +
                                                            " - " +
                                                            motoqueiro.telefone
                                                        }
                                                    />
                                                ))}
                                            </RadioGroup>
                                        </FormControl>
                                    </Col>
                                ) : (
                                    <React.Fragment>
                                        <Col
                                            xs={12}
                                            md={12}
                                            lg={12}
                                            style={{ textAlign: "center" }}
                                        >
                                            <Typography>Nenhum motoqueiro encontrado.</Typography>
                                        </Col>
                                    </React.Fragment>
                                )}
                                <React.Fragment>
                                    <Col xs={12} md={12} lg={12}></Col>
                                </React.Fragment>
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    setModalMotoqueiro(false)
                                }}
                            >
                                Voltar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openConfirmacaoPedidosRepetidosFui}
                        onClose={() => setOpenConfirmacaoPedidosRepetidosFui(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"Informativo"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {messageOpenConfirmacaoPedidosRepetidosFui}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => setOpenConfirmacaoPedidosRepetidosFui(false)}
                                color="default"
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={() => {
                                    calcularValorEntregaFuiApp()
                                    setOpenConfirmacaoPedidosRepetidosFui(false)
                                }}
                                color="primary"
                                autoFocus
                            >
                                Consultar mesmo assim
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalEntregadorFuiDelivery?.openModal}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setPedidosEntregaFuiApp([])
                            setModalEntregadorFuiDelivery({
                                ...modalEntregadorFuiDelivery,
                                openModal: false,
                                pedidoSelecionado: null,
                            })
                        }}
                    >
                        <DialogTitle>{"Fui App Delivery"}</DialogTitle>
                        <DialogContent>
                            <Row>
                                <React.Fragment>
                                    <Col xs={12} md={12} lg={12}>
                                        <Typography variant="body2" component="p">
                                            Agrupar com outros pedidos
                                        </Typography>

                                        {showCheckbox(
                                            modalEntregadorFuiDelivery?.pedidoSelecionado
                                        )}
                                    </Col>
                                </React.Fragment>
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    validarPedidosJaEnviadosFuiDelivery()
                                }}
                            >
                                Calcular Valor
                            </Button>
                            <Button
                                onClick={() => {
                                    setPedidosEntregaFuiApp([])
                                    setModalEntregadorFuiDelivery({
                                        ...modalEntregadorFuiDelivery,
                                        openModal: false,
                                        pedidoSelecionado: null,
                                    })
                                }}
                            >
                                Voltar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {showDialogConfirmarValoresFui()}

                    <Dialog
                        fullScreen={fullScreen}
                        open={modalInformacoes}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={() => {
                            setModalInformacoes(false)
                        }}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
                    >
                        <DialogTitle id="alert-dialog-slide-title">
                            {"Informações do Pedido"}
                            {user.perfil === "ADMINISTRADOR" ? (
                                <Button
                                    onClick={() => {
                                        window.open(
                                            "https://sistema.appclientefiel.com.br/web/historicoclientefornecedor/" +
                                                modalInformacoesPedido.customer.id,
                                            "_blank"
                                        )
                                    }}
                                    variant="contained"
                                    style={{ marginLeft: "1em", float: "right" }}
                                >
                                    <AccountCircleIcon />
                                </Button>
                            ) : null}
                        </DialogTitle>
                        <DialogContent>
                            {tabStatus === "CRUD" &&
                                (modalInformacoesPedido.status === 0 ? (
                                    <Row>
                                        <Col xs={12} md={12} lg={12}>
                                            <Button
                                                onClick={() => {
                                                    mudarStatusPara(
                                                        1,
                                                        autorizacao,
                                                        modalInformacoesPedido,
                                                        modalInformacoesPedidoIndex
                                                    )
                                                }}
                                                fullWidth
                                                variant="contained"
                                                style={{
                                                    marginTop: "1em",
                                                    backgroundColor: "#28a745",
                                                    color: "white",
                                                }}
                                            >
                                                Aceitar
                                            </Button>
                                        </Col>
                                        <Col xs={12} md={12} lg={12}>
                                            <Button
                                                onClick={() => {
                                                    mudarStatusPara(
                                                        -1,
                                                        autorizacao,
                                                        modalInformacoesPedido,
                                                        modalInformacoesPedidoIndex
                                                    )
                                                }}
                                                fullWidth
                                                variant="contained"
                                                style={{
                                                    marginTop: "1em",
                                                    backgroundColor: "#dc3545",
                                                    color: "white",
                                                }}
                                            >
                                                Cancelar
                                            </Button>
                                        </Col>
                                    </Row>
                                ) : (
                                    <Row>
                                        {modalInformacoesPedido.status > 0 ? (
                                            <React.Fragment>
                                                <Col xs={12} md={6} lg={6}>
                                                    <Button
                                                        onClick={() => {
                                                            mudarStatusPara(
                                                                -1,
                                                                autorizacao,
                                                                modalInformacoesPedido,
                                                                modalInformacoesPedidoIndex
                                                            )
                                                        }}
                                                        fullWidth
                                                        variant="contained"
                                                        style={{
                                                            marginTop: "1em",
                                                            backgroundColor: "#dc3545",
                                                            color: "white",
                                                        }}
                                                    >
                                                        Cancelar
                                                    </Button>
                                                </Col>
                                                <Col xs={12} md={6} lg={6}>
                                                    <Button
                                                        fullWidth
                                                        onClick={() => {
                                                            mudarStatusPara(
                                                                7,
                                                                autorizacao,
                                                                modalInformacoesPedido,
                                                                modalInformacoesPedidoIndex
                                                            )
                                                        }}
                                                        variant="contained"
                                                        style={{
                                                            marginTop: "1em",
                                                            backgroundColor: "#fd7e14",
                                                            color: "white",
                                                        }}
                                                    >
                                                        Em Preparação
                                                    </Button>
                                                </Col>
                                                <Col xs={12} md={6} lg={6}>
                                                    {
                                                        // (modalInformacoesPedido.deliveryAddress?.streetName === "Buscar no local" || modalInformacoesPedido.mesa)
                                                        modalInformacoesPedido.type === "1" ||
                                                        modalInformacoesPedido.type === "2" ? (
                                                            <Button
                                                                fullWidth
                                                                onClick={() => {
                                                                    mudarStatusPara(
                                                                        6,
                                                                        autorizacao,
                                                                        modalInformacoesPedido,
                                                                        modalInformacoesPedidoIndex
                                                                    )
                                                                }}
                                                                variant="contained"
                                                                style={{
                                                                    marginTop: "1em",
                                                                    backgroundColor: "#0080ff",
                                                                    color: "white",
                                                                }}
                                                            >
                                                                Pronto p/ Retirada
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                fullWidth
                                                                onClick={() => {
                                                                    mudarStatusPara(
                                                                        3,
                                                                        autorizacao,
                                                                        modalInformacoesPedido,
                                                                        modalInformacoesPedidoIndex
                                                                    )
                                                                }}
                                                                variant="contained"
                                                                style={{
                                                                    marginTop: "1em",
                                                                    backgroundColor: "#0080ff",
                                                                    color: "white",
                                                                }}
                                                            >
                                                                Saiu p/ Entrega
                                                            </Button>
                                                        )
                                                    }
                                                </Col>
                                                <Col xs={12} md={6} lg={6}>
                                                    <Button
                                                        fullWidth
                                                        onClick={() => {
                                                            mudarStatusPara(
                                                                4,
                                                                autorizacao,
                                                                modalInformacoesPedido,
                                                                modalInformacoesPedidoIndex
                                                            )
                                                        }}
                                                        variant="contained"
                                                        style={{
                                                            marginTop: "1em",
                                                            backgroundColor: "#28a745",
                                                            color: "white",
                                                        }}
                                                    >
                                                        Finalizado
                                                    </Button>
                                                </Col>
                                            </React.Fragment>
                                        ) : null}
                                    </Row>
                                ))}

                            <Row style={{ justifyContent: "center", marginTop: "2em" }}>
                                {modalInformacoesPedido.plataforma === "ifood_integracao" ? (
                                    <img
                                        src={iconIfood}
                                        style={{ width: "100px" }}
                                        alt="pedido ifood"
                                    />
                                ) : RepresentanteSelector.getRepresentante().isClienteFiel() ? (
                                    <img
                                        src={iconClienteFiel}
                                        style={{ width: "100px" }}
                                        alt="pedido cliente fiel"
                                    />
                                ) : null}
                            </Row>
                            <Row style={{ justifyContent: "center" }}>
                                <div id="textoHTML">
                                    {modalInformacoesPedido.texto &&
                                        textoHTML(
                                            configuracoes?.user?.perfil === "DELIVERY_BASICO" &&
                                                (modalInformacoesPedido.status === 4 ||
                                                    modalInformacoesPedido.status < 0)
                                                ? modalInformacoesPedido.texto.replace(
                                                      /(R\$\s*)?(\()?([0-9]+[.,]{1}[0-9])(.*)/g, // RegEx para remover valores
                                                      ""
                                                  )
                                                : modalInformacoesPedido.texto
                                        )}
                                </div>
                            </Row>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    // setModalInformacoes(false)
                                    mandarImprimir({
                                        pedido: modalInformacoesPedido,
                                        texto: modalInformacoesPedido.texto,
                                        qtd: 1,
                                        qrcode: verificarPrintQRCode(modalInformacoesPedido),
                                    })
                                }}
                            >
                                imprimir
                            </Button>
                            <Button
                                onClick={() => {
                                    setModalInformacoes(false)
                                }}
                            >
                                voltar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Row>
                <ListaIntegracoes
                    expandListaIntegracoes={expandListaIntegracoes}
                    setExpandListaIntegracoes={setExpandListaIntegracoes}
                    statusLojaIfood={statusLojaIfood}
                />
            </Container>
        )
    }
}
